(function () {
  const WM_IS_RECOMMENDATIONS_FEED = window.WM_FEED_SOURCE === 'recommendations';
  const WM_IS_WEEKLY_DIGS_FEED = window.WM_FEED_SOURCE === 'weekly_digs';
  const WM_IS_PERSONALIZED_FEED = WM_IS_RECOMMENDATIONS_FEED || WM_IS_WEEKLY_DIGS_FEED;
  const WM_TRACK_RECOMMENDATION_EVENTS = window.WM_FEED_SOURCE !== 'wishlist';
  if (!WM_TRACK_RECOMMENDATION_EVENTS) return;
  if (window.WM_RECOMMENDATIONS_INSTALLED) return;
  window.WM_RECOMMENDATIONS_INSTALLED = true;

  const PROXY_BASE = String(window.WM_RECOMMENDATIONS_PROXY_BASE || '/apps/wm-recommendations').replace(/\/+$/, '');
  const ANON_ID_KEY = 'wm_recommendations_anon_id_v1';
  const FOR_YOU_NOTICE_ACCEPTED_KEY = 'wm_recommendations_for_you_notice_accepted_v1';
  const SESSION_ID_KEY = 'wm_recommendations_session_id_v1';
  const DEBUG_TOKEN_KEY = 'wm_recommendations_debug_token';
  const PAGE_VIEW_ID = wmRecommendationUuid();
  const IMPRESSION_SENT_ATTR = 'data-wm-recommendation-impression-sent';
  const TRACKED_LISTEN_THRESHOLDS = [10, 25, 50, 80];
  try {
    if (WM_IS_PERSONALIZED_FEED) {
      const url = new URL(window.location.href);
      if (url.searchParams.get('view') === 'grid') {
        url.searchParams.delete('view');
        url.searchParams.set('wm_view', 'grid');
      }
      if (url.searchParams.has('sort_by')) url.searchParams.delete('sort_by');
      if (url.toString() !== window.location.href) history.replaceState({}, '', url.toString());
    }
  } catch (err) {}
  const REQUEST_PARAMS = new URLSearchParams(window.location.search);
  const DEBUG_REQUESTED = REQUEST_PARAMS.get('wm_rec_debug') === '1';
  const FOR_YOU_GRID_VIEW = WM_IS_PERSONALIZED_FEED && (REQUEST_PARAMS.get('wm_view') === 'grid' || REQUEST_PARAMS.get('view') === 'grid');
  if (FOR_YOU_GRID_VIEW) window.WM_FOR_YOU_GRID_VIEW = true;
  if (FOR_YOU_GRID_VIEW && WM_IS_WEEKLY_DIGS_FEED) document.documentElement.classList.add('wm-weekly-digs-grid-view');
  if (WM_IS_WEEKLY_DIGS_FEED) document.documentElement.classList.add('wm-weekly-digs-pending');
  const DEBUG_ENABLED = wmRecommendationsEnabled() && DEBUG_REQUESTED && !!wmRecommendationDebugToken();
  const FOR_YOU_GRID_PRODUCT_JSON_CACHE = new Map();
  const FOR_YOU_GRID_PREORDER_RELEASE_DATE_CACHE = new Map();
  const RERANK_EVENT_TYPES = new Set(['product_view', 'product_click', 'wishlist_add', 'add_to_cart', 'audio_listen_10', 'audio_listen_25', 'audio_listen_50', 'audio_listen_80', 'card_dwell_8s', 'quick_skip_card']);
  const SESSION_EVENT_WEIGHTS = {
    product_view: 12,
    product_click: 8,
    wishlist_add: 40,
    add_to_cart: 60,
    audio_listen_10: 5,
    audio_listen_25: 10,
    audio_listen_50: 18,
    audio_listen_80: 30,
    card_dwell_8s: 3,
    quick_skip_card: -2
  };
  const SESSION_ENTITY_MULTIPLIERS = {
    genres: 0.6,
    sub_genres: 0.45,
    mood_style: 0.3,
    labels: 0.25,
    artists: 0.2,
    other_tags: 0
  };
  const SESSION_ENTITY_TYPES = {
    genres: 'genre',
    sub_genres: 'sub_genre',
    mood_style: 'mood_style',
    labels: 'label',
    artists: 'artist',
    other_tags: 'other_tag'
  };
  const IGNORED_RECOMMENDATION_TAG_SLUGS = new Set([
    'new',
    'preorder',
    'summersale',
    'summer-sale',
    'sale',
    'clearance',
    'sold-out',
    'coming-soon',
    'back-in-stock'
  ]);
  const IGNORED_RECOMMENDATION_TAG_PATTERNS = [
    /^wm-/,
    /^sale-/,
    /-sale(?:-|$)/,
    /^filter-/,
    /^badge-/,
    /^status-/,
    /^collection-/
  ];
  let wmRecommendationRefreshTimer = null;
  let wmPersonalisationPromptRetryCount = 0;
  const wmSessionAffinity = new Map();
  const wmSessionTagProducts = new Map();
  const wmBranchAffinity = new Map();
  let wmBranchUpdatedAt = 0;
  let wmBranchSignalScore = 0;

  function wmRecommendationUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'wm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function wmRecommendationPersonalisationAllowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(
        privacy &&
        typeof privacy.preferencesProcessingAllowed === 'function' &&
        privacy.preferencesProcessingAllowed()
      );
    } catch (e) {
      return false;
    }
  }

  function wmForYouNoticeAccepted() {
    try {
      return localStorage.getItem(FOR_YOU_NOTICE_ACCEPTED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function wmSetForYouNoticeAccepted() {
    try {
      localStorage.setItem(FOR_YOU_NOTICE_ACCEPTED_KEY, '1');
    } catch (e) {}
  }

  function wmCustomerIsLoggedIn() {
    if (window.WM_CUSTOMER_LOGGED_IN === true) return true;
    if (window.WM_CUSTOMER_AUTH_STATUS && window.WM_CUSTOMER_AUTH_STATUS.authenticated === true) return true;
    if (window.WM_CUSTOMER_AUTH_STATUS && window.WM_CUSTOMER_AUTH_STATUS.authenticated === false) return false;
    try {
      return sessionStorage.getItem('wm_customer_auth_confirmed') === '1';
    } catch (e) {
      return false;
    }
  }

  function wmRecommendationsEnabled() {
    return wmRecommendationPersonalisationAllowed() || wmCustomerIsLoggedIn() || wmForYouNoticeAccepted();
  }

  function wmShopifyConsentBannerVisible() {
    const selectors = [
      '#shopify-pc__banner',
      '#shopify-pc__preferences',
      '[id^="shopify-pc__banner"]',
      '[id^="shopify-pc__prefs"]',
      '[data-shopify-privacy-banner]',
      '[data-shopify-privacy-preferences]'
    ];

    return selectors.some(selector => {
      const el = document.querySelector(selector);
      if (!el) return false;
      const style = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    });
  }

  function wmShopifyConsentDecisionKnown() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return false;

      if (typeof privacy.getTrackingConsent === 'function') {
        const status = privacy.getTrackingConsent();
        return !!status && status !== 'no_interaction';
      }

      if (typeof privacy.currentVisitorConsent === 'function') {
        const consent = privacy.currentVisitorConsent();
        if (!consent || typeof consent !== 'object') return false;
        return Object.values(consent).some(value => value !== undefined && value !== null && value !== '');
      }
    } catch (e) {}

    return false;
  }

  function wmOpenPrivacyPreferences() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.showPreferences === 'function') {
        privacy.showPreferences();
        return true;
      }

      if (privacy && typeof privacy.openPreferences === 'function') {
        privacy.openPreferences();
        return true;
      }
    } catch (e) {}

    const manageButton =
      document.getElementById('shopify-pc__banner__btn-manage-prefs') ||
      document.querySelector('[data-shopify-privacy-preferences-button]') ||
      document.querySelector('[aria-controls="shopify-pc__preferences"]') ||
      document.querySelector('button[id*="manage"][id*="prefs"], button[id*="preferences"]');
    if (manageButton) {
      manageButton.click();
      return true;
    }

    try {
      window.dispatchEvent(new Event('shopify:privacy-preferences:show'));
      document.dispatchEvent(new Event('shopify:privacy-preferences:show'));
    } catch (e) {}

    return false;
  }

  function wmTurnOnRecommendationPersonalisation(callback) {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.setTrackingConsent === 'function') {
        privacy.setTrackingConsent({ preferences: true }, () => {
          if (typeof callback === 'function') callback();
        });
        return true;
      }
    } catch (e) {}

    return false;
  }

  function wmRemovePersonalisationPrompt() {
    const overlay = document.getElementById('wmRecommendationConsentPrompt');
    if (overlay) overlay.remove();
    document.documentElement.classList.remove('wm-recommendations-consent-open');
  }

  function wmInstallConsentPromptStyles() {
    if (document.getElementById('wmRecommendationConsentPromptStyles')) return;

    const style = document.createElement('style');
    style.id = 'wmRecommendationConsentPromptStyles';
    style.textContent = `
      html.wm-recommendations-consent-open #audioUnlockOverlay {
        display: none !important;
      }

      .wm-rec-consent-overlay {
        position: fixed;
        inset: 0;
        z-index: 999998;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        background: rgba(24, 18, 18, 0.72);
      }

      .wm-rec-consent-prompt {
        box-sizing: border-box;
        width: min(100%, 720px);
        max-width: 560px;
        padding: 22px;
        border: 2px solid rgba(255, 242, 233, 0.86);
        border-radius: 8px;
        background: #2B2424;
        color: #FFF2E9;
        font: inherit;
        box-shadow: 0 18px 60px rgba(0, 0, 0, 0.42);
      }

      .wm-rec-consent-prompt strong,
      .wm-rec-consent-prompt span {
        display: block;
      }

      .wm-rec-consent-prompt strong {
        margin-bottom: 8px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.04em;
      }

      .wm-rec-consent-prompt span {
        font-size: 0.95rem;
        line-height: 1.35;
      }

      .wm-rec-consent-prompt p {
        margin: 0 0 10px;
        font-size: 0.95rem;
        line-height: 1.35;
      }

      .wm-rec-consent-prompt p:last-of-type {
        margin-bottom: 0;
      }

      .wm-rec-consent-prompt__actions {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px;
        margin-top: 18px;
      }

      .wm-rec-consent-prompt button {
        width: 100%;
        min-height: 42px;
        padding: 0 16px;
        border-radius: 8px;
        border: 1.5px solid #FFF2E9;
        background: transparent;
        color: #FFF2E9;
        font: inherit;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        cursor: pointer;
      }

      .wm-rec-consent-prompt [data-wm-rec-consent-open] {
        background: #eab782;
        color: #2B2424;
        border-color: #eab782;
      }

      @media (max-width: 480px) {
        .wm-rec-consent-prompt__actions {
          grid-template-columns: 1fr;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function wmInstallPersonalisationPrompt() {
    if (!WM_IS_RECOMMENDATIONS_FEED || wmRecommendationsEnabled() || document.getElementById('wmRecommendationConsentPrompt')) return;

    const mount = () => {
      if (document.getElementById('wmRecommendationConsentPrompt')) return;
      if (wmRecommendationsEnabled()) return;

      if (wmShopifyConsentBannerVisible() || !wmShopifyConsentDecisionKnown()) {
        if (wmPersonalisationPromptRetryCount < 20) {
          wmPersonalisationPromptRetryCount += 1;
          setTimeout(mount, 250);
        }
        return;
      }

      wmInstallConsentPromptStyles();

      const overlay = document.createElement('div');
      overlay.id = 'wmRecommendationConsentPrompt';
      overlay.className = 'wm-rec-consent-overlay';
      document.documentElement.classList.add('wm-recommendations-consent-open');

      const prompt = document.createElement('div');
      prompt.className = 'wm-rec-consent-prompt';
      prompt.innerHTML = `
        <strong>For You recommendations</strong>
        <p>The For You feed uses your activity on Wax Merchant, like plays, skips and wishlist actions, to improve record recommendations.</p>
        <p>We only collect this data to recommend records you might like. It is not used for marketing and is not shared with advertising platforms.</p>
        <p>If you would prefer this data not to be tracked, choose Decline and you can browse our records without recommendations or recommendation tracking.</p>
        <div class="wm-rec-consent-prompt__actions">
          <button type="button" data-wm-rec-consent-open>Accept</button>
          <button type="button" data-wm-rec-consent-dismiss>Decline</button>
        </div>
      `;

      const openButton = prompt.querySelector('[data-wm-rec-consent-open]');
      const dismissButton = prompt.querySelector('[data-wm-rec-consent-dismiss]');
      if (openButton) openButton.addEventListener('click', () => {
        wmSetForYouNoticeAccepted();
        openButton.disabled = true;
        openButton.textContent = 'Loading';
        wmRemovePersonalisationPrompt();
        window.location.reload();
      });
      if (dismissButton) dismissButton.addEventListener('click', () => {
        wmRemovePersonalisationPrompt();
        window.location.href = '/collections/all-records';
      });

      overlay.appendChild(prompt);
      document.body.appendChild(overlay);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    } else {
      mount();
    }
  }

  function wmBindConsentReload() {
    const handleConsentCollected = () => {
      if (wmRecommendationPersonalisationAllowed()) {
        window.location.reload();
      } else {
        wmPersonalisationPromptRetryCount = 0;
        wmInstallPersonalisationPrompt();
      }
    };

    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.addEventListener === 'function') {
        privacy.addEventListener('visitorConsentCollected', handleConsentCollected);
      }
    } catch (e) {}

    try {
      window.addEventListener('visitorConsentCollected', handleConsentCollected);
      document.addEventListener('visitorConsentCollected', handleConsentCollected);
    } catch (e) {}
  }

  function wmUseConsentFallback() {
    if (!WM_IS_RECOMMENDATIONS_FEED) return;

    window.WM_RECOMMENDATIONS_READY = (async function () {
      wmInstallPersonalisationPrompt();
      return window.WM_ACTIVE_COLLECTION_INDEX || [];
    })();
  }

  function wmGetAnonymousId() {
    try {
      let id = localStorage.getItem(ANON_ID_KEY);
      if (!id) {
        id = wmRecommendationUuid();
        localStorage.setItem(ANON_ID_KEY, id);
      }
      return id;
    } catch (e) {
      return wmRecommendationUuid();
    }
  }

  function wmGetExistingAnonymousId() {
    try {
      return String(localStorage.getItem(ANON_ID_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  function wmGetSessionId() {
    try {
      let id = sessionStorage.getItem(SESSION_ID_KEY);
      if (!id) {
        id = wmRecommendationUuid();
        sessionStorage.setItem(SESSION_ID_KEY, id);
      }
      return id;
    } catch (e) {
      return wmRecommendationUuid();
    }
  }

  function wmRecommendationDebugToken() {
    try {
      return String(localStorage.getItem(DEBUG_TOKEN_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  function wmDebugHeaders() {
    const token = wmRecommendationDebugToken();
    return token ? { 'X-WM-Debug-Token': token } : {};
  }

  function wmRecommendationIdentity() {
    if (!wmRecommendationsEnabled()) return {};

    if (wmCustomerIsLoggedIn() && !wmRecommendationPersonalisationAllowed() && !wmForYouNoticeAccepted()) {
      const existingAnonymousId = wmGetExistingAnonymousId();
      return existingAnonymousId ? { anonymous_id: existingAnonymousId } : {};
    }

    return {
      // Logged-in customer identity is supplied by Shopify's signed app-proxy query.
      // Do not send browser-readable customer IDs in the JSON body.
      anonymous_id: wmGetAnonymousId()
    };
  }

  function wmNormalizeHandle(item) {
    return item && String(item.handle || item.product_handle || '').trim();
  }

  function wmPushUnique(list, value) {
    const clean = String(value || '').trim();
    if (!clean || list.includes(clean)) return;
    list.push(clean);
  }

  function wmRecommendationSlug(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function wmIsIgnoredRecommendationTag(value) {
    const key = wmRecommendationSlug(value);
    if (!key) return true;
    if (IGNORED_RECOMMENDATION_TAG_SLUGS.has(key)) return true;
    return IGNORED_RECOMMENDATION_TAG_PATTERNS.some(pattern => pattern.test(key));
  }

  function wmCleanRecommendationValues(values) {
    return (Array.isArray(values) ? values : [])
      .map(value => String(value || '').trim())
      .filter(value => value && !wmIsIgnoredRecommendationTag(value));
  }

  function wmSessionAffinityPayload() {
    const combined = new Map(wmSessionAffinity);

    wmSessionTagProducts.forEach((productHandles, key) => {
      const count = productHandles instanceof Set ? productHandles.size : 0;
      if (count < 2) return;

      const boost = count >= 4 ? 60 : (count >= 3 ? 40 : 20);
      combined.set(key, (combined.get(key) || 0) + boost);
    });

    return Array.from(combined.entries())
      .filter(([, score]) => Number.isFinite(score) && score !== 0)
      .map(([key, score]) => ({
        key,
        score: Math.round(score * 100) / 100
      }));
  }

  function wmBranchAffinityPayload() {
    if (!wmBranchUpdatedAt || Date.now() - wmBranchUpdatedAt > 15 * 60 * 1000) return [];

    return Array.from(wmBranchAffinity.entries())
      .filter(([, score]) => Number.isFinite(score) && score > 0)
      .map(([key, score]) => ({
        key,
        score: Math.round(score * 100) / 100
      }));
  }

  function wmBranchStrengthPayload() {
    if (!wmBranchUpdatedAt || Date.now() - wmBranchUpdatedAt > 15 * 60 * 1000) return 0;
    if (wmBranchSignalScore >= 80) return 3;
    if (wmBranchSignalScore >= 35) return 2;
    if (wmBranchSignalScore > 0) return 1;
    return 0;
  }

  function wmApplySessionAffinity(eventType, metadata) {
    const weight = SESSION_EVENT_WEIGHTS[eventType] || 0;
    if (!weight || !metadata) return;

    Object.entries(SESSION_ENTITY_MULTIPLIERS).forEach(([metadataKey, multiplier]) => {
      if (!multiplier) return;
      const entityType = SESSION_ENTITY_TYPES[metadataKey];
      const values = Array.isArray(metadata[metadataKey]) ? metadata[metadataKey] : [];

      values.forEach(value => {
        const clean = String(value || '').trim();
        const valueSlug = wmRecommendationSlug(clean);
        if (!valueSlug) return;

        const key = `${entityType}:${valueSlug}`;
        const delta = weight * multiplier;
        wmSessionAffinity.set(key, (wmSessionAffinity.get(key) || 0) + delta);
      });
    });
  }

  function wmTrackSessionCluster(eventType, metadata, productHandle) {
    if (!metadata || !productHandle || eventType === 'quick_skip_card') return;

    ['sub_genres', 'mood_style'].forEach(metadataKey => {
      const entityType = SESSION_ENTITY_TYPES[metadataKey];
      const values = Array.isArray(metadata[metadataKey]) ? metadata[metadataKey] : [];

      values.forEach(value => {
        const valueSlug = wmRecommendationSlug(value);
        if (!valueSlug) return;

        const key = `${entityType}:${valueSlug}`;
        if (!wmSessionTagProducts.has(key)) wmSessionTagProducts.set(key, new Set());
        wmSessionTagProducts.get(key).add(productHandle);
      });
    });
  }

  function wmApplyBranchAffinity(eventType, metadata, recommendation) {
    if (!metadata || !recommendation) return;
    const source = recommendation.blend_source || '';
    if (!['exploration', 'new_arrival', 'archive', 'branch'].includes(source)) return;

    if (eventType === 'quick_skip_card') {
      wmBranchSignalScore = Math.max(0, wmBranchSignalScore - 8);
      return;
    }

    const weight = Math.max(0, SESSION_EVENT_WEIGHTS[eventType] || 0);
    if (!weight) return;
    const branchMultiplier = source === 'exploration' ? 2 : (source === 'branch' ? 1.6 : 1.35);

    ['sub_genres', 'mood_style'].forEach(metadataKey => {
      const entityType = SESSION_ENTITY_TYPES[metadataKey];
      const values = Array.isArray(metadata[metadataKey]) ? metadata[metadataKey] : [];

      values.forEach(value => {
        const valueSlug = wmRecommendationSlug(value);
        if (!valueSlug) return;

        const key = `${entityType}:${valueSlug}`;
        wmBranchAffinity.set(key, (wmBranchAffinity.get(key) || 0) + weight * branchMultiplier);
      });
    });

    wmBranchUpdatedAt = Date.now();
    wmBranchSignalScore += weight * branchMultiplier;
  }

  function wmParseRecommendationTags(tags) {
    const parsed = {
      artists: [],
      labels: [],
      genres: [],
      sub_genres: [],
      mood_style: [],
      other_tags: []
    };

    if (!Array.isArray(tags)) return parsed;

    tags.forEach(tag => {
      const raw = String(tag || '').trim();
      if (!raw) return;

      const lower = raw.toLowerCase();
      const colonIndex = raw.indexOf(':');
      const prefix = colonIndex >= 0 ? raw.slice(0, colonIndex).trim().toLowerCase() : '';
      const value = colonIndex >= 0 ? raw.slice(colonIndex + 1).trim() : raw;
      if (wmIsIgnoredRecommendationTag(raw) || wmIsIgnoredRecommendationTag(value)) return;

      if (prefix === 'distributor' || prefix === 'dist' || prefix === 'distributed-by') {
        return;
      }

      if (prefix === 'artist') {
        wmPushUnique(parsed.artists, value);
        return;
      }

      if (prefix === 'label') {
        wmPushUnique(parsed.labels, value);
        return;
      }

      if (prefix === 'subgenre' || prefix === 'sub-genre') {
        wmPushUnique(parsed.sub_genres, value);
        return;
      }

      if (prefix === 'descriptor' || prefix === 'mood' || prefix === 'style') {
        wmPushUnique(parsed.mood_style, value);
        return;
      }

      if (prefix) {
        wmPushUnique(parsed.other_tags, raw);
        return;
      }

      if (lower === 'new' || lower === 'preorder') {
        wmPushUnique(parsed.other_tags, raw);
      } else {
        wmPushUnique(parsed.genres, raw);
      }
    });

    return parsed;
  }

  function wmWaitForCollectionIndex(timeoutMs = 8000) {
    if (window.WM_COLLECTION_INDEX_READY && typeof window.WM_COLLECTION_INDEX_READY.then === 'function') {
      return Promise.race([
        window.WM_COLLECTION_INDEX_READY.catch(() => []),
        new Promise(resolve => setTimeout(() => resolve(window.WM_COLLECTION_INDEX || []), timeoutMs))
      ]);
    }

    return Promise.resolve(window.WM_COLLECTION_INDEX || []);
  }

  async function wmFetchRecommendedHandles(source) {
    const endpoint = WM_IS_WEEKLY_DIGS_FEED ? '/weekly-digs' : '/feed';
    const url = new URL(PROXY_BASE + endpoint, window.location.origin);
    const identity = wmRecommendationIdentity();
    if (identity.anonymous_id) url.searchParams.set('anonymous_id', identity.anonymous_id);

    const candidates = source
      .map(item => {
        const handle = wmNormalizeHandle(item);
        if (!handle) return null;

        return {
          handle,
          available: item.available !== false,
          is_preorder: item.is_preorder === true,
          inventory_quantity: item.inventory_quantity ?? null,
          inventory_policy: item.inventory_policy || null,
          created_at: item.created_at || null,
          stock_movement_at: item.stock_movement_at || null,
          release_date: item.release_date || null,
          preorder_release_date: item.preorder_release_date || null,
          tags: Array.isArray(item.tags) ? item.tags : []
        };
      })
      .filter(Boolean);

    const res = await fetch(url.pathname + url.search, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        ...identity,
        context: {
          source: WM_IS_WEEKLY_DIGS_FEED ? 'weekly_digs' : 'recommendations',
          path: window.location.pathname,
          session_id: wmGetSessionId(),
          page_view_id: PAGE_VIEW_ID,
          session_affinity: wmSessionAffinityPayload(),
          branch_affinity: wmBranchAffinityPayload(),
          branch_strength: wmBranchStrengthPayload()
        },
        candidates
      })
    });

    const json = await res.json();
    window.WM_RECOMMENDATIONS_STATUS = json.status || 'ready';
    window.WM_RECOMMENDATIONS_WEEK_ID = json.week_id || '';
    window.WM_WEEKLY_DIGS_FALLBACK_LEVEL = json.fallback_level || 'none';
    window.WM_WEEKLY_DIGS_FALLBACK_MESSAGE = json.fallback_message || '';
    if (!res.ok) {
      if (WM_IS_WEEKLY_DIGS_FEED && json.status === 'login_required') {
        window.WM_CUSTOMER_LOGGED_IN = false;
        window.WM_CUSTOMER_AUTH_STATUS = { authenticated: false, source: 'weekly_digs' };
        try { sessionStorage.removeItem('wm_customer_auth_confirmed'); } catch(e) {}
        return [];
      }
      throw new Error('Recommendations feed failed: ' + res.status);
    }
    if (WM_IS_WEEKLY_DIGS_FEED && (json.status === 'not_ready' || json.status === 'login_required')) {
      return [];
    }
    const ranked = Array.isArray(json.products) ? json.products : (Array.isArray(json.handles) ? json.handles : []);

    return ranked
      .map(item => {
        if (typeof item === 'string') return { handle: item };
        return {
          handle: wmNormalizeHandle(item),
          score: item.score,
          raw_score: item.raw_score,
          contrast_factor: item.contrast_factor,
          fatigue_factor: item.fatigue_factor,
          archive_age_days: item.archive_age_days,
          archive_boost: item.archive_boost,
          branch_score: item.branch_score,
          weekly_digs_tier: item.weekly_digs_tier || '',
          weekly_digs_history_repeat: item.weekly_digs_history_repeat === true,
          weekly_digs_fallback: item.weekly_digs_fallback === true,
          blend_source: item.blend_source || item.source || '',
          reason_codes: Array.isArray(item.reason_codes) ? item.reason_codes : []
        };
      })
      .filter(item => item.handle);
  }

  function wmRenderedProductHandles() {
    const container = document.getElementById('verticalSwipeContainer');
    if (!container) return [];

    return Array.from(container.querySelectorAll('.product-slide[data-product-handle]'))
      .map(slide => slide.getAttribute('data-product-handle') || '')
      .filter(Boolean);
  }

  function wmBuildFallbackRecommendations(source) {
    return source
      .filter(item => item && wmNormalizeHandle(item))
      .filter(item => item.available !== false)
      .map(item => ({
        handle: wmNormalizeHandle(item),
        score: 0,
        reason_codes: ['fallback:collection_order']
      }));
  }

  function wmEscapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  const WM_WEEKLY_DIGS_BLOCKED_TAG_SLUGS = IGNORED_RECOMMENDATION_TAG_SLUGS;
  const WM_WEEKLY_DIGS_MIN_GENRE_PRODUCTS = 20;
  const WM_WEEKLY_DIGS_MIN_SUBGENRE_PRODUCTS = 14;
  const WM_WEEKLY_DIGS_MIN_DESCRIPTOR_PRODUCTS = 6;
  const WM_WEEKLY_DIGS_BROAD_MIN_SUBGENRE_PRODUCTS = 9;
  const WM_WEEKLY_DIGS_WIDE_MIN_SUBGENRE_PRODUCTS = 6;
  const WM_WEEKLY_DIGS_BROAD_MIN_DESCRIPTOR_PRODUCTS = 4;
  const WM_WEEKLY_DIGS_WIDE_MIN_DESCRIPTOR_PRODUCTS = 3;
  const WM_WEEKLY_DIGS_DESCRIPTOR_OPTIONS = [
    'Warm',
    'Deep',
    'Dubby',
    'Hypnotic',
    'Groovy',
    'Funky',
    'Soulful',
    'Dreamy',
    'Atmospheric',
    'Trippy',
    'Raw',
    'Lo-Fi',
    'Bouncy',
    'Percussive',
    'Melodic',
    'Dark',
    'Euphoric',
    'Cosmic',
    'Driving',
    'Swingy',
    'Rolling',
    'Organic',
    'Acidic',
    'Broken',
    'Sun-soaked',
    'Dusty',
    'Ravey',
    'Club'
  ];

  function wmWeeklyDigsDisplayLabel(value) {
    const clean = String(value || '').trim().replace(/\s+/g, ' ');
    if (!clean) return '';
    return clean.charAt(0).toUpperCase() + clean.slice(1);
  }

  let WM_WEEKLY_DIGS_LIVE_PRODUCTS_CACHE = null;
  let WM_WEEKLY_DIGS_TAG_STATS_CACHE = null;
  const WM_WEEKLY_DIGS_OPTIONS_CACHE = new Map();

  function wmWeeklyDigsParsedTags(product) {
    if (!product) return {};
    if (!product.__wmWeeklyDigsParsedTags) {
      product.__wmWeeklyDigsParsedTags = wmParseRecommendationTags(product.tags);
    }
    return product.__wmWeeklyDigsParsedTags;
  }

  function wmWeeklyDigsLiveTagStats() {
    if (WM_WEEKLY_DIGS_TAG_STATS_CACHE) return WM_WEEKLY_DIGS_TAG_STATS_CACHE;

    const source = Array.isArray(window.WM_COLLECTION_INDEX) ? window.WM_COLLECTION_INDEX : [];
    const groups = {
      genres: new Map(),
      sub_genres: new Map(),
      mood_style: new Map()
    };

    source.forEach(item => {
      const parsed = wmWeeklyDigsParsedTags(item);
      Object.keys(groups).forEach(key => {
        (parsed[key] || []).forEach(value => {
          const clean = String(value || '').trim();
          if (!clean) return;
          const slugKey = wmRecommendationSlug(clean);
          if (WM_WEEKLY_DIGS_BLOCKED_TAG_SLUGS.has(slugKey)) return;
          const current = groups[key].get(slugKey) || { label: clean, count: 0 };
          current.count += 1;
          groups[key].set(slugKey, current);
        });
      });
    });

    WM_WEEKLY_DIGS_TAG_STATS_CACHE = groups;
    return groups;
  }

  function wmWeeklyDigsLiveProducts() {
    if (WM_WEEKLY_DIGS_LIVE_PRODUCTS_CACHE) return WM_WEEKLY_DIGS_LIVE_PRODUCTS_CACHE;
    WM_WEEKLY_DIGS_LIVE_PRODUCTS_CACHE = (Array.isArray(window.WM_COLLECTION_INDEX) ? window.WM_COLLECTION_INDEX : [])
      .filter(item => item && item.available !== false);
    return WM_WEEKLY_DIGS_LIVE_PRODUCTS_CACHE;
  }

  function wmWeeklyDigsProductMatches(product, kind, selectedSlugs) {
    if (!product || !selectedSlugs || !selectedSlugs.size) return true;
    const parsed = wmWeeklyDigsParsedTags(product);
    return (parsed[kind] || []).some(value => selectedSlugs.has(wmRecommendationSlug(value)));
  }

  function wmWeeklyDigsProductsForSelection({ genres = [], subGenres = [], moods = [] } = {}) {
    const genreSlugs = new Set(genres.map(wmRecommendationSlug).filter(Boolean));
    const subgenreSlugs = new Set(subGenres.map(wmRecommendationSlug).filter(Boolean));
    const moodSlugs = new Set(moods.map(wmRecommendationSlug).filter(Boolean));

    return wmWeeklyDigsLiveProducts()
      .filter(product => wmWeeklyDigsProductMatches(product, 'genres', genreSlugs))
      .filter(product => wmWeeklyDigsProductMatches(product, 'sub_genres', subgenreSlugs))
      .filter(product => wmWeeklyDigsProductMatches(product, 'mood_style', moodSlugs));
  }

  function wmWeeklyDigsProductsForSupport({ genres = [], subGenres = [], moods = [] } = {}) {
    const genreSlugs = new Set(genres.map(wmRecommendationSlug).filter(Boolean));
    const subgenreSlugs = new Set(subGenres.map(wmRecommendationSlug).filter(Boolean));
    const moodSlugs = new Set(moods.map(wmRecommendationSlug).filter(Boolean));

    return wmWeeklyDigsLiveProducts()
      .filter(product => {
        const hasGenre = !genreSlugs.size || wmWeeklyDigsProductMatches(product, 'genres', genreSlugs);
        const hasSubgenre = !subgenreSlugs.size || wmWeeklyDigsProductMatches(product, 'sub_genres', subgenreSlugs);
        return subgenreSlugs.size ? hasSubgenre : hasGenre;
      })
      .filter(product => wmWeeklyDigsProductMatches(product, 'mood_style', moodSlugs));
  }

  function wmWeeklyDigsSelectedGenreCount(genres) {
    return new Set((genres || []).map(wmRecommendationSlug).filter(Boolean)).size;
  }

  function wmWeeklyDigsMinSubgenreProductsForGenres(genres) {
    const count = wmWeeklyDigsSelectedGenreCount(genres);
    if (count >= 3) return WM_WEEKLY_DIGS_WIDE_MIN_SUBGENRE_PRODUCTS;
    if (count >= 2) return WM_WEEKLY_DIGS_BROAD_MIN_SUBGENRE_PRODUCTS;
    return WM_WEEKLY_DIGS_MIN_SUBGENRE_PRODUCTS;
  }

  function wmWeeklyDigsMinDescriptorProductsForGenres(genres) {
    const count = wmWeeklyDigsSelectedGenreCount(genres);
    if (count >= 3) return WM_WEEKLY_DIGS_WIDE_MIN_DESCRIPTOR_PRODUCTS;
    if (count >= 2) return WM_WEEKLY_DIGS_BROAD_MIN_DESCRIPTOR_PRODUCTS;
    return WM_WEEKLY_DIGS_MIN_DESCRIPTOR_PRODUCTS;
  }

  function wmWeeklyDigsHasSupportedDescriptor(products, minProducts = WM_WEEKLY_DIGS_MIN_DESCRIPTOR_PRODUCTS) {
    return wmWeeklyDigsTopDescriptorsForProducts(products, 1, minProducts).length > 0;
  }

  function wmWeeklyDigsTopDescriptorsForProducts(products, limit = 14, minProducts = 0) {
    const allowed = new Set(WM_WEEKLY_DIGS_DESCRIPTOR_OPTIONS.map(wmRecommendationSlug));
    const map = new Map();
    products.forEach(product => {
      const parsed = wmWeeklyDigsParsedTags(product);
      (parsed.mood_style || []).forEach(value => {
        const clean = wmWeeklyDigsDisplayLabel(value);
        const slug = wmRecommendationSlug(clean);
        if (!slug || !allowed.has(slug)) return;
        const current = map.get(slug) || { label: clean, count: 0 };
        current.count += 1;
        map.set(slug, current);
      });
    });

    return Array.from(map.values())
      .filter(row => row.count >= minProducts)
      .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
      .map(row => row.label)
      .slice(0, limit);
  }

  function wmWeeklyDigsInferredDescriptors(state) {
    const selectedGenres = new Set((state.genres || []).map(wmRecommendationSlug));
    const selectedSubgenres = new Set((state.sub_genres || []).map(wmRecommendationSlug));
    const selectedMoods = new Set((state.mood_style || []).map(wmRecommendationSlug));
    const products = wmWeeklyDigsLiveProducts();
    const subgenreProducts = products
      .filter(product => wmWeeklyDigsProductMatches(product, 'sub_genres', selectedSubgenres));
    const genreProducts = products
      .filter(product => wmWeeklyDigsProductMatches(product, 'genres', selectedGenres));
    const withoutExplicit = value => !selectedMoods.has(wmRecommendationSlug(value));

    return {
      inferred_subgenre_mood_style: wmWeeklyDigsTopDescriptorsForProducts(subgenreProducts, 8).filter(withoutExplicit),
      inferred_genre_mood_style: wmWeeklyDigsTopDescriptorsForProducts(genreProducts, 8).filter(withoutExplicit)
    };
  }

  function wmWeeklyDigsSupportedGenreSlugs(rows) {
    const products = wmWeeklyDigsLiveProducts();
    const genreCounts = new Map();

    products.forEach(product => {
      const parsed = wmWeeklyDigsParsedTags(product);
      (parsed.genres || []).forEach(value => {
        const slug = wmRecommendationSlug(value);
        if (!slug || WM_WEEKLY_DIGS_BLOCKED_TAG_SLUGS.has(slug)) return;
        genreCounts.set(slug, (genreCounts.get(slug) || 0) + 1);
      });
    });

    const supported = new Set();
    rows.forEach(row => {
      const genreSlug = wmRecommendationSlug(row.genre);
      if ((genreCounts.get(genreSlug) || 0) < WM_WEEKLY_DIGS_MIN_GENRE_PRODUCTS) return;
      const subgenreProducts = wmWeeklyDigsProductsForSupport({
        genres: [row.genre],
        subGenres: [row.sub_genre]
      });
      if (subgenreProducts.length < WM_WEEKLY_DIGS_MIN_SUBGENRE_PRODUCTS) return;
      if (!wmWeeklyDigsHasSupportedDescriptor(subgenreProducts)) return;
      supported.add(genreSlug);
    });

    return supported;
  }

  function wmWeeklyDigsTopTags() {
    const groups = wmWeeklyDigsLiveTagStats();
    const fallback = {
      genres: ['House', 'Tech House', 'UK Garage', 'Techno', 'Electro', 'Disco', 'Minimal', 'Progressive'],
      sub_genres: ['Deep House', 'Electro', 'Dub Techno', 'Breakbeat', 'UK Garage', 'Balearic', 'Acid', 'Minimal'],
      mood_style: ['Deep', 'Warm', 'Percussive', 'Euphoric', 'Dreamy', 'Heavy', 'Smooth', 'Leftfield']
    };

    return Object.fromEntries(Object.entries(groups).map(([key, map]) => {
      const values = Array.from(map.values())
        .filter(row => key !== 'genres' || row.count >= WM_WEEKLY_DIGS_MIN_GENRE_PRODUCTS)
        .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
        .map(row => wmWeeklyDigsDisplayLabel(row.label))
        .slice(0, key === 'genres' ? 8 : 14);
      return [key, values.length ? values : fallback[key]];
    }));
  }

  function wmWeeklyDigsTaxonomyRows() {
    return [
      ['House', 'Deep House', 'Warm'],
      ['House', 'Soulful House', 'Deep'],
      ['House', 'Minimal House', 'Dubby'],
      ['House', 'Microhouse', 'Hypnotic'],
      ['House', 'Acid House', 'Groovy'],
      ['House', 'Breakbeat House', 'Funky'],
      ['House', 'Garage House', 'Soulful'],
      ['House', 'Jackin House', 'Dreamy'],
      ['House', 'Chicago House', 'Atmospheric'],
      ['House', 'New York House', 'Trippy'],
      ['House', 'Italo House', 'Psychedelic'],
      ['House', 'Gospel House', 'Raw'],
      ['House', 'Jazzy House', 'Lo-Fi'],
      ['House', 'Vocal House', 'Bouncy'],
      ['House', 'Balearic House', 'Percussive'],
      ['House', 'Disco House', 'Melodic'],
      ['House', 'Afro House', 'Dark'],
      ['House', 'Latin House', 'Euphoric'],
      ['House', 'Lounge House', 'Cosmic'],
      ['House', 'Classic House', 'Spacey'],
      ['House', 'Pumping House', 'Driving'],
      ['Tech House', 'Deep Tech', 'Swingy'],
      ['Tech House', 'Minimal Tech', 'Skippy'],
      ['Tech House', 'Raw Tech House', 'Bass-heavy'],
      ['Tech House', 'Dub Tech House', 'Rolling'],
      ['Tech House', 'Hypnotic Tech House', 'Wobbly'],
      ['Tech House', 'Tribal Tech House', 'Trancey'],
      ['Tech House', 'Rolling Tech House', 'Organic'],
      ['Tech House', 'Classic Tech House', 'Chuggy'],
      ['Tech House', 'UK Tech House', 'Acidic'],
      ['Tech House', 'Progressive Tech House', 'Robotic'],
      ['Tech House', 'Modern Tech House', 'Broken'],
      ['UK Garage', '2-Step', 'Mechanical'],
      ['UK Garage', 'Speed Garage', 'Sun-soaked'],
      ['UK Garage', 'Garage House', 'Dusty'],
      ['UK Garage', 'Deep Garage', 'Ravey'],
      ['UK Garage', 'Dub Garage', 'Steppy'],
      ['UK Garage', 'Dark Garage', 'Crunchy'],
      ['UK Garage', 'Bass Garage', 'Club'],
      ['UK Garage', 'UK Funky', ''],
      ['UK Garage', 'Bassline', ''],
      ['UK Garage', '4 x 4', ''],
      ['UK Garage', 'Soulful Garage', ''],
      ['UK Garage', 'Bumpy Garage', ''],
      ['Progressive', 'Deep Progressive', ''],
      ['Progressive', 'Melodic House', ''],
      ['Progressive', 'Hypnotic Progressive', ''],
      ['Progressive', 'Tribal Progressive', ''],
      ['Progressive', 'Atmospheric Progressive', ''],
      ['Progressive', 'Progressive House', ''],
      ['Progressive', 'Progressive Trance', ''],
      ['Progressive', 'Indie Dance', ''],
      ['Techno', 'Deep Techno', ''],
      ['Techno', 'Dub Techno', ''],
      ['Techno', 'Hypnotic Techno', ''],
      ['Techno', 'Rolling Techno', ''],
      ['Techno', 'Tribal Techno', ''],
      ['Techno', 'Minimal Techno', ''],
      ['Techno', 'Atmospheric Techno', ''],
      ['Techno', 'Detroit Techno', ''],
      ['Techno', 'Acid Techno', ''],
      ['Techno', 'Hardgroove', ''],
      ['Techno', 'Industrial Techno', ''],
      ['Techno', 'Melodic Techno', ''],
      ['Electro', 'Detroit Electro', ''],
      ['Electro', 'Deep Electro', ''],
      ['Electro', 'Electro Funk', ''],
      ['Electro', 'Acid Electro', ''],
      ['Electro', 'Breakbeat Electro', ''],
      ['Electro', 'Atmospheric Electro', ''],
      ['Electro', 'Industrial Electro', ''],
      ['Electro', 'Electro Techno', ''],
      ['Electro', 'Leftfield Electro', ''],
      ['Disco', 'Disco House', ''],
      ['Disco', 'Nu Disco', ''],
      ['Disco', 'Cosmic Disco', ''],
      ['Disco', 'Balearic Disco', ''],
      ['Disco', 'Boogie', ''],
      ['Disco', 'Afro Disco', ''],
      ['Disco', 'Italo Disco', ''],
      ['Disco', 'Jazz-Funk', ''],
      ['Disco', 'Disco Edits', ''],
      ['Disco', 'Dub Disco', ''],
      ['Minimal', 'Minimal House', ''],
      ['Minimal', 'Minimal Tech', ''],
      ['Minimal', 'Romanian Minimal', ''],
      ['Minimal', 'Deep Minimal', ''],
      ['Minimal', 'Dub Minimal', ''],
      ['Minimal', 'Hypnotic Minimal', ''],
      ['Minimal', 'Raw Minimal', ''],
      ['Minimal', 'Minimal Techno', ''],
      ['Trance', 'Progressive Trance', ''],
      ['Trance', 'Deep Trance', ''],
      ['Trance', 'Hypnotic Trance', ''],
      ['Trance', 'Atmospheric Trance', ''],
      ['Trance', 'Goa Trance', ''],
      ['Trance', 'Dream Trance', ''],
      ['Trance', 'Acid Trance', ''],
      ['Trance', 'Trance Techno', ''],
      ['Trance', 'Cosmic Trance', ''],
      ['Downtempo', 'Ambient Downtempo', ''],
      ['Downtempo', 'Balearic Downtempo', ''],
      ['Downtempo', 'Dub Downtempo', ''],
      ['Downtempo', 'Organic Downtempo', ''],
      ['Downtempo', 'Trip-Hop', ''],
      ['Downtempo', 'Electronica', ''],
      ['Downtempo', 'Cosmic Downtempo', ''],
      ['Downtempo', 'Slow House', ''],
      ['Downtempo', 'Leftfield Electronica', ''],
      ['Breakbeat', 'Electro Breaks', ''],
      ['Breakbeat', 'Progressive Breaks', ''],
      ['Breakbeat', 'Deep Breaks', ''],
      ['Breakbeat', 'Atmospheric Breaks', ''],
      ['Breakbeat', 'Garage Breaks', ''],
      ['Breakbeat', 'Breakbeat Techno', ''],
      ['Breakbeat', 'Hardcore Breaks', ''],
      ['Breakbeat', 'Dub Breaks', ''],
      ['Breakbeat', 'Broken Beat', '']
    ].map(row => ({
      genre: row[0],
      sub_genre: row[1]
    }));
  }

  function wmWeeklyDigsUnique(values, limit = 40) {
    const seen = new Set();
    return values
      .map(value => String(value || '').trim())
      .filter(value => {
        if (!value) return false;
        const key = wmRecommendationSlug(value);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .slice(0, limit);
  }

  function wmWeeklyDigsInitialState(root) {
    if (!root.__wmWeeklyDigsSelections) {
      root.__wmWeeklyDigsSelections = {
        step: 0,
        genres: [],
        sub_genres: [],
        mood_style: []
      };
    }
    return root.__wmWeeklyDigsSelections;
  }

  function wmWeeklyDigsOptionsForStep(state) {
    const cacheKey = [
      state.step || 0,
      (state.genres || []).map(wmRecommendationSlug).sort().join(','),
      (state.sub_genres || []).map(wmRecommendationSlug).sort().join(','),
      (state.mood_style || []).map(wmRecommendationSlug).sort().join(',')
    ].join('|');
    if (WM_WEEKLY_DIGS_OPTIONS_CACHE.has(cacheKey)) {
      return WM_WEEKLY_DIGS_OPTIONS_CACHE.get(cacheKey);
    }

    const rows = wmWeeklyDigsTaxonomyRows();
    const tags = wmWeeklyDigsTopTags();
    const liveGenres = wmWeeklyDigsSupportedGenreSlugs(rows);
    const selectedGenres = new Set((state.genres || []).map(wmRecommendationSlug));
    const selectedSubgenres = new Set((state.sub_genres || []).map(wmRecommendationSlug));
    const supportedRows = rows.filter(row => liveGenres.has(wmRecommendationSlug(row.genre)));
    const hasLiveProducts = wmWeeklyDigsLiveProducts().length > 0;
    const optionRows = hasLiveProducts ? supportedRows : (supportedRows.length ? supportedRows : rows);

    if (state.step === 0) {
      WM_WEEKLY_DIGS_OPTIONS_CACHE.set(cacheKey, []);
      return [];
    }

    if (state.step === 1) {
      const options = wmWeeklyDigsUnique(optionRows.map(row => row.genre), 8);
      WM_WEEKLY_DIGS_OPTIONS_CACHE.set(cacheKey, options);
      return options;
    }

    if (state.step === 2) {
      const minSubgenreProducts = wmWeeklyDigsMinSubgenreProductsForGenres(state.genres || []);
      const minDescriptorProducts = wmWeeklyDigsMinDescriptorProductsForGenres(state.genres || []);
      const filtered = selectedGenres.size
        ? optionRows.filter(row => selectedGenres.has(wmRecommendationSlug(row.genre))).map(row => row.sub_genre)
        : tags.sub_genres || [];
      const options = wmWeeklyDigsUnique(filtered.filter(value => {
        if (!hasLiveProducts) return true;
        const products = wmWeeklyDigsProductsForSupport({
          genres: state.genres || [],
          subGenres: [value]
        });
        return products.length >= minSubgenreProducts &&
          wmWeeklyDigsHasSupportedDescriptor(products, minDescriptorProducts);
      }), 24);
      WM_WEEKLY_DIGS_OPTIONS_CACHE.set(cacheKey, options);
      return options;
    }

    const minDescriptorProducts = wmWeeklyDigsMinDescriptorProductsForGenres(state.genres || []);
    const matchingProducts = wmWeeklyDigsProductsForSupport({
      genres: state.genres || [],
      subGenres: state.sub_genres || []
    });
    const options = wmWeeklyDigsUnique(
      wmWeeklyDigsTopDescriptorsForProducts(matchingProducts, 14, minDescriptorProducts),
      14
    );
    WM_WEEKLY_DIGS_OPTIONS_CACHE.set(cacheKey, options);
    return options;
  }

  function wmWeeklyDigsStepCopy(step) {
    const copy = [
      {
        key: 'intro',
        eyebrow: '',
        title: 'Build your Weekly Digs',
        hint: "20 records we've picked for you, based on your taste. Refreshed weekly."
      },
      {
        key: 'genres',
        eyebrow: '1 / 3',
        title: 'Choose your genres',
        hint: "Tell us what you're into."
      },
      {
        key: 'sub_genres',
        eyebrow: '2 / 3',
        title: 'Refine your sound',
        hint: "Choose the styles you're into."
      },
      {
        key: 'mood_style',
        eyebrow: '3 / 3',
        title: 'Choose the mood',
        hint: "Pick the energy you're looking for."
      }
    ];
    return copy[Math.max(0, Math.min(copy.length - 1, step || 0))];
  }

  function wmWeeklyDigsOnboardingMarkup() {
    return `
      <div class="wm-weekly-digs-onboarding" data-wm-weekly-onboarding>
        <div class="wm-weekly-digs-onboarding__stage" data-wm-weekly-step-body></div>
        <div class="wm-weekly-digs-onboarding__footer">
          <span data-wm-weekly-onboarding-status></span>
          <div class="wm-weekly-digs-onboarding__actions">
            <button class="wm-weekly-digs-onboarding__back" type="button" data-wm-weekly-back>Back</button>
            <button class="wm-weekly-digs-onboarding__submit" type="button" data-wm-weekly-next disabled>Next</button>
          </div>
        </div>
      </div>
    `;
  }

  function wmWeeklyDigsSelectedMetadata(root) {
    const state = wmWeeklyDigsInitialState(root);
    const metadata = {
      artists: [],
      labels: [],
      genres: [],
      sub_genres: [],
      mood_style: [],
      inferred_subgenre_mood_style: [],
      inferred_genre_mood_style: [],
      other_tags: [],
      raw_tags: []
    };

    ['genres', 'sub_genres', 'mood_style'].forEach(kind => {
      (state[kind] || []).forEach(value => {
        if (!value || !Array.isArray(metadata[kind])) return;
        wmPushUnique(metadata[kind], value);
        const prefix = kind === 'sub_genres' ? 'subgenre' : (kind === 'mood_style' ? 'descriptor' : '');
        wmPushUnique(metadata.raw_tags, prefix ? `${prefix}:${value}` : value);
      });
    });

    const inferred = wmWeeklyDigsInferredDescriptors(state);
    metadata.inferred_subgenre_mood_style = wmWeeklyDigsUnique(
      inferred.inferred_subgenre_mood_style,
      8
    );
    const subgenreInferred = new Set(metadata.inferred_subgenre_mood_style.map(wmRecommendationSlug));
    metadata.inferred_genre_mood_style = wmWeeklyDigsUnique(
      inferred.inferred_genre_mood_style.filter(value => !subgenreInferred.has(wmRecommendationSlug(value))),
      8
    );

    return metadata;
  }

  function wmRenderWeeklyDigsOnboardingStep(root) {
    const state = wmWeeklyDigsInitialState(root);
    const step = wmWeeklyDigsStepCopy(state.step);
    const body = root.querySelector('[data-wm-weekly-step-body]');
    const meter = root.querySelector('[data-wm-weekly-meter]');
    if (!body) return;

    const options = wmWeeklyDigsOptionsForStep(state);
    const selected = new Set((state[step.key] || []).map(wmRecommendationSlug));
    const isIntro = step.key === 'intro';
    body.innerHTML = isIntro
      ? `
        <section class="wm-weekly-digs-onboarding__group wm-weekly-digs-onboarding__group--intro" aria-label="${wmEscapeHtml(step.title)}">
          <div class="wm-weekly-digs-onboarding__intro-card">
            <strong>${wmEscapeHtml(step.title)}</strong>
            <p>${wmEscapeHtml(step.hint)}</p>
          </div>
        </section>
      `
      : `
        <section class="wm-weekly-digs-onboarding__group" aria-label="${wmEscapeHtml(step.title)}">
          <div class="wm-weekly-digs-onboarding__group-head">
            <span>${wmEscapeHtml(step.eyebrow)}</span>
            <h3>${wmEscapeHtml(step.title)}</h3>
            <p>${wmEscapeHtml(step.hint)}</p>
          </div>
          <div class="wm-weekly-digs-onboarding__pills${options.length > 10 ? ' is-dense' : ''}" data-wm-weekly-option-count="${options.length}">
            ${options.map(value => `
              <button
                class="wm-weekly-digs-pill"
                type="button"
                data-wm-weekly-pill
                data-kind="${wmEscapeHtml(step.key)}"
                data-value="${wmEscapeHtml(value)}"
                aria-pressed="${selected.has(wmRecommendationSlug(value)) ? 'true' : 'false'}"
              >${wmEscapeHtml(wmWeeklyDigsDisplayLabel(value))}</button>
            `).join('')}
          </div>
        </section>
      `;

    if (meter) meter.style.width = `${(Math.max(0, state.step) / 3) * 100}%`;
    wmUpdateWeeklyDigsOnboardingState(root);
    window.requestAnimationFrame(wmSyncWeeklyDigsOnboardingViewport);
  }

  function wmUpdateWeeklyDigsOnboardingState(root) {
    const state = wmWeeklyDigsInitialState(root);
    const metadata = wmWeeklyDigsSelectedMetadata(root);
    const total = metadata.genres.length + metadata.sub_genres.length + metadata.mood_style.length;
    const hasSound = metadata.sub_genres.length > 0;
    const hasFeel = metadata.mood_style.length > 0;
    const next = root.querySelector('[data-wm-weekly-next]');
    const back = root.querySelector('[data-wm-weekly-back]');
    const status = root.querySelector('[data-wm-weekly-onboarding-status]');
    const ready = total >= 3 && hasSound && hasFeel;
    const currentKey = wmWeeklyDigsStepCopy(state.step).key;
    const canContinue = currentKey === 'intro' || (state[currentKey] || []).length > 0;

    if (back) back.hidden = state.step === 0;
    if (next) {
      next.disabled = state.step === 3 ? !ready : !canContinue;
      next.textContent = state.step === 3 ? 'Build Weekly Digs' : (state.step === 0 ? 'Start' : 'Next');
    }
    if (status) {
      if (ready) {
        status.textContent = `${total} picked. Ready to build.`;
      } else if (state.step <= 1) {
        status.textContent = '';
      } else if (state.step === 2) {
        status.textContent = 'Add at least one sound.';
      } else {
        status.textContent = `${total} picked. Add one feel to finish.`;
      }
    }

    return { metadata, ready };
  }

  function wmInstallWeeklyDigsOnboarding() {
    if (window.WM_WEEKLY_DIGS_ONBOARDING_INSTALLED) return;
    window.WM_WEEKLY_DIGS_ONBOARDING_INSTALLED = true;

    document.addEventListener('click', event => {
      const pill = event.target.closest('[data-wm-weekly-pill]');
      if (pill) {
        const root = pill.closest('[data-wm-weekly-onboarding]');
        if (!root) return;
        const state = wmWeeklyDigsInitialState(root);
        const kind = pill.dataset.kind;
        const value = String(pill.dataset.value || '').trim();
        if (!value || !Array.isArray(state[kind])) return;
        const selected = pill.getAttribute('aria-pressed') === 'true';
        state[kind] = selected
          ? state[kind].filter(item => wmRecommendationSlug(item) !== wmRecommendationSlug(value))
          : state[kind].concat(value);
        if (kind === 'genres') {
          const availableSubgenres = new Set(wmWeeklyDigsOptionsForStep({ ...state, step: 2 }).map(wmRecommendationSlug));
          state.sub_genres = state.sub_genres.filter(item => availableSubgenres.has(wmRecommendationSlug(item)));
        }
        if (kind === 'genres' || kind === 'sub_genres') {
          const availableMoods = new Set(wmWeeklyDigsOptionsForStep({ ...state, step: 3 }).map(wmRecommendationSlug));
          state.mood_style = state.mood_style.filter(item => availableMoods.has(wmRecommendationSlug(item)));
        }
        pill.setAttribute('aria-pressed', selected ? 'false' : 'true');
        wmUpdateWeeklyDigsOnboardingState(root);
        return;
      }

      const back = event.target.closest('[data-wm-weekly-back]');
      if (back) {
        const root = back.closest('[data-wm-weekly-onboarding]');
        if (!root) return;
        const state = wmWeeklyDigsInitialState(root);
        state.step = Math.max(0, state.step - 1);
        wmRenderWeeklyDigsOnboardingStep(root);
        return;
      }

      const next = event.target.closest('[data-wm-weekly-next]');
      if (!next || next.disabled) return;
      const root = next.closest('[data-wm-weekly-onboarding]');
      if (!root) return;
      const state = wmWeeklyDigsInitialState(root);
      if (state.step < 3) {
        state.step += 1;
        wmRenderWeeklyDigsOnboardingStep(root);
        return;
      }

      const { metadata, ready } = wmUpdateWeeklyDigsOnboardingState(root);
      if (!ready) return;

      next.disabled = true;
      next.textContent = 'Building...';
      wmPostRecommendationEvent('/events', {
        event_type: 'taste_onboarding',
        source: 'weekly_digs_onboarding',
        product_handle: 'weekly-digs-onboarding',
        product_id: null,
        recommendation: null,
        metadata
      }).then(response => {
        if (!response || !response.ok) throw new Error('Onboarding failed');
        const status = root.querySelector('[data-wm-weekly-onboarding-status]');
        if (status) status.textContent = 'Saved. Building your first set...';
        setTimeout(() => window.location.reload(), 900);
      }).catch(err => {
        console.warn('[WM Recommendations] Weekly Digs onboarding failed', err);
        next.disabled = false;
        next.textContent = 'Try again';
        const status = root.querySelector('[data-wm-weekly-onboarding-status]');
        if (status) status.textContent = 'Could not save that yet. Try again.';
      });
    }, true);
  }

  function wmSyncWeeklyDigsOnboardingViewport() {
    if (!document.documentElement.classList.contains('wm-weekly-digs-onboarding-active')) return;

    const message = document.getElementById('endOfFeedMessage');
    if (!message) return;

    const viewport = window.visualViewport;
    const viewportHeight = viewport && viewport.height ? viewport.height : window.innerHeight;
    const rect = message.getBoundingClientRect();
    const isMobile = window.matchMedia && window.matchMedia('(max-width: 759px)').matches;
    const bottomReserve = isMobile ? 94 : 92;
    const measuredHeight = Math.max(320, Math.floor(viewportHeight - Math.max(0, rect.top) - bottomReserve));

    message.style.setProperty('--wm-weekly-digs-message-h', `${measuredHeight}px`);
  }

  function wmBindWeeklyDigsOnboardingViewport() {
    if (window.WM_WEEKLY_DIGS_ONBOARDING_VIEWPORT_BOUND) return;
    window.WM_WEEKLY_DIGS_ONBOARDING_VIEWPORT_BOUND = true;

    const sync = () => {
      window.requestAnimationFrame(wmSyncWeeklyDigsOnboardingViewport);
    };

    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('orientationchange', sync, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', sync, { passive: true });
      window.visualViewport.addEventListener('scroll', sync, { passive: true });
    }
  }

  function wmShowWeeklyDigsNotReady() {
    if (!WM_IS_WEEKLY_DIGS_FEED) return;
    document.querySelector('[data-wm-weekly-digs-fallback-notice]')?.remove();
    window.WM_WEEKLY_DIGS_ONBOARDING_ACTIVE = true;
    document.documentElement.classList.remove('wm-weekly-digs-pending');
    document.documentElement.classList.add('wm-weekly-digs-onboarding-active');
    wmBindWeeklyDigsOnboardingViewport();

    if (!document.getElementById('wmWeeklyDigsEmptyStyles')) {
      const style = document.createElement('style');
      style.id = 'wmWeeklyDigsEmptyStyles';
      style.textContent = `
        html.wm-weekly-digs-onboarding-active #audioUnlockOverlay {
          display: none !important;
        }
        html.wm-weekly-digs-onboarding-active body {
          background: #2b2424;
          overflow: hidden !important;
        }
        html.wm-weekly-digs-onboarding-active .sorting-bar {
          display: none !important;
        }
        html.wm-weekly-digs-onboarding-active #endOfFeedMessage {
          display: block !important;
          height: var(--wm-weekly-digs-message-h, calc(100svh - 188px)) !important;
          overflow: hidden !important;
          padding: 0 !important;
          margin: 0 !important;
          color: #FFF7EE;
        }
        html.wm-weekly-digs-onboarding-active #verticalSwipeContainer {
          min-height: 0 !important;
          height: auto !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        .wm-weekly-digs-empty {
          display: grid;
          gap: clamp(12px, 2.2svh, 24px);
          max-width: 420px;
          margin: 18vh auto;
          padding: 0 20px;
          text-align: center;
          color: inherit;
        }
        .wm-weekly-digs-empty strong {
          display: block;
          font-size: clamp(1.25rem, 2vw, 1.7rem);
          line-height: 1.15;
          text-transform: uppercase;
        }
        .wm-weekly-digs-empty span {
          display: block;
          font-size: 1rem;
          line-height: 1.35;
        }
        .wm-weekly-digs-empty a {
          justify-self: center;
          display: inline-flex;
          align-items: center;
          min-height: 42px;
          padding: 0 18px;
          border: 2px solid currentColor;
          color: inherit;
          text-decoration: none;
          text-transform: uppercase;
          font-weight: 800;
        }
        .wm-weekly-digs-onboarding {
          --wm-digs-ink: #FFE2E9;
          --wm-digs-bg: #2b2424;
          --wm-digs-panel: #2f2828;
          --wm-digs-line: rgba(255, 226, 233, 0.26);
          --wm-digs-tan: #EAB782;
          --wm-digs-pink: #FFE2E9;
          display: grid;
          grid-template-rows: minmax(0, 1fr) auto;
          gap: clamp(12px, 2.4svh, 22px);
          height: 100%;
          min-height: 0;
          width: min(100%, 780px);
          margin: 0 auto;
          padding: 0 14px 8px;
          color: var(--wm-digs-ink);
          box-sizing: border-box;
        }
        .wm-weekly-digs-onboarding__intro {
          display: none;
        }
        .wm-weekly-digs-onboarding__kicker {
          display: none;
        }
        .wm-weekly-digs-onboarding__intro strong {
          font-size: clamp(1.35rem, 5.8vw, 2.15rem);
          line-height: 1;
          text-transform: uppercase;
        }
        .wm-weekly-digs-onboarding__intro span {
          max-width: 620px;
          font-size: clamp(0.86rem, 2.4vw, 1.08rem);
          line-height: 1.22;
        }
        .wm-weekly-digs-onboarding__meter {
          display: none;
        }
        .wm-weekly-digs-onboarding__meter span {
          display: none;
        }
        .wm-weekly-digs-onboarding__stage {
          min-height: 0;
          overflow: hidden;
          display: grid;
          align-items: center;
          padding: clamp(18px, 4.6vw, 30px);
          border: 0;
          border-radius: 0;
          background: transparent;
          box-shadow: none;
          position: relative;
        }
        .wm-weekly-digs-onboarding__stage::before {
          display: none;
        }
        .wm-weekly-digs-onboarding__group {
          display: grid;
          grid-template-rows: auto minmax(0, 1fr);
          gap: clamp(12px, 2.2svh, 20px);
          min-height: 0;
          height: 100%;
        }
        .wm-weekly-digs-onboarding__group--intro {
          grid-template-rows: minmax(0, 1fr);
          align-items: center;
        }
        .wm-weekly-digs-onboarding__intro-card {
          display: grid;
          justify-items: center;
          gap: clamp(14px, 2.4svh, 22px);
          max-width: 680px;
          margin: 0 auto;
          text-align: center;
        }
        .wm-weekly-digs-onboarding__intro-card strong {
          font-size: clamp(2.1rem, 7vw, 4rem);
          line-height: 0.98;
          text-transform: uppercase;
        }
        .wm-weekly-digs-onboarding__intro-card p {
          margin: 0;
          max-width: 34em;
          font-size: clamp(1rem, 3.2vw, 1.24rem);
          line-height: 1.24;
          opacity: 0.9;
        }
        .wm-weekly-digs-onboarding__group-head {
          display: grid;
          gap: 4px;
        }
        .wm-weekly-digs-onboarding__group-head span {
          color: var(--wm-digs-tan);
          font-size: 0.68rem;
          font-weight: 900;
          line-height: 1;
          text-transform: uppercase;
        }
        .wm-weekly-digs-onboarding__group h3 {
          margin: 0;
          font-size: clamp(1.32rem, 5.8vw, 2.35rem);
          line-height: 1;
          text-transform: uppercase;
          letter-spacing: 0;
        }
        .wm-weekly-digs-onboarding__group p {
          margin: 0;
          max-width: 560px;
          font-size: clamp(0.88rem, 3.1vw, 1rem);
          line-height: 1.2;
          opacity: 0.86;
        }
        .wm-weekly-digs-onboarding__pills {
          display: flex;
          flex-wrap: wrap;
          align-content: start;
          justify-content: center;
          gap: clamp(8px, 2vw, 12px);
          min-height: 0;
          max-height: 100%;
          overflow-y: auto;
          padding: 1px 2px 22px;
          scrollbar-width: none;
          -webkit-overflow-scrolling: touch;
          mask-image: linear-gradient(to bottom, #000 0, #000 calc(100% - 26px), transparent 100%);
          -webkit-mask-image: linear-gradient(to bottom, #000 0, #000 calc(100% - 26px), transparent 100%);
        }
        .wm-weekly-digs-onboarding__pills::-webkit-scrollbar {
          display: none;
        }
        .wm-weekly-digs-pill {
          min-height: clamp(36px, 7.4vw, 42px);
          border: 2px solid rgba(255, 247, 238, 0.84);
          border-radius: 999px;
          background: rgba(255, 247, 238, 0.06);
          color: var(--wm-digs-ink);
          padding: 0 clamp(12px, 3.6vw, 18px);
          font: inherit;
          font-size: clamp(0.82rem, 3.1vw, 0.98rem);
          font-weight: 800;
          line-height: 1;
          cursor: pointer;
          touch-action: manipulation;
          transition: transform 140ms ease, background 140ms ease, border-color 140ms ease, color 140ms ease, box-shadow 140ms ease;
        }
        .wm-weekly-digs-pill:hover {
          transform: translateY(-1px);
          border-color: var(--wm-digs-tan);
        }
        .wm-weekly-digs-pill[aria-pressed="true"] {
          background: var(--wm-digs-tan);
          border-color: var(--wm-digs-tan);
          color: var(--wm-digs-bg);
          box-shadow: 4px 4px 0 rgba(255, 226, 233, 0.28);
          transform: translate(-1px, -1px);
        }
        .wm-weekly-digs-onboarding__footer {
          z-index: 20;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          margin: 12px 0 0;
          padding: 0;
          background: transparent;
          border: 0;
          border-radius: 0;
          text-align: center;
          backdrop-filter: none;
          -webkit-backdrop-filter: none;
        }
        .wm-weekly-digs-onboarding__footer span {
          display: none;
        }
        .wm-weekly-digs-onboarding__actions {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 10px;
          width: 100%;
        }
        .wm-weekly-digs-onboarding__back,
        .wm-weekly-digs-onboarding__submit {
          width: min(100%, 520px);
          min-height: 46px;
          border: 2px solid var(--wm-digs-ink);
          border-radius: 999px;
          padding: 0 14px;
          font: inherit;
          font-size: 0.78rem;
          font-weight: 900;
          text-transform: uppercase;
          cursor: pointer;
        }
        .wm-weekly-digs-onboarding__back {
          order: 2;
          background: transparent;
          color: var(--wm-digs-ink);
        }
        .wm-weekly-digs-onboarding__submit {
          order: 1;
          background: var(--wm-digs-tan);
          border-color: var(--wm-digs-tan);
          color: var(--wm-digs-bg);
          min-width: 190px;
        }
        .wm-weekly-digs-onboarding__back[hidden] {
          display: none;
        }
        .wm-weekly-digs-onboarding__submit:disabled {
          opacity: 0.45;
          cursor: not-allowed;
        }
        .wm-weekly-digs-onboarding__fallback {
          display: inline-flex;
          justify-content: center;
          width: 100%;
          margin-top: 7px;
          color: var(--wm-digs-ink);
          font-size: 0.76rem;
          font-weight: 800;
          text-transform: uppercase;
        }
        @media (max-width: 759px) {
          html.wm-weekly-digs-onboarding-active #endOfFeedMessage {
            height: var(--wm-weekly-digs-message-h, calc(100svh - 190px)) !important;
            height: var(--wm-weekly-digs-message-h, calc(100dvh - 190px)) !important;
          }
          .wm-weekly-digs-onboarding {
            grid-template-rows: minmax(0, 1fr) auto;
            align-content: stretch;
            height: 100%;
            min-height: 0;
            margin-top: 0;
            padding-left: 24px;
            padding-right: 24px;
            padding-bottom: clamp(18px, 3.6svh, 34px);
          }
          .wm-weekly-digs-onboarding__intro {
            display: none;
          }
          .wm-weekly-digs-onboarding__intro strong {
            font-size: clamp(1.45rem, 6.2vw, 1.9rem);
            max-width: 10em;
            margin: 0 auto;
          }
          .wm-weekly-digs-onboarding__intro span {
            font-size: clamp(0.88rem, 3.1vw, 1rem);
            max-width: 22em;
            margin: 0 auto;
          }
          .wm-weekly-digs-onboarding__stage {
            align-self: stretch;
            width: 100%;
            max-height: none;
            min-height: 0;
            align-items: center;
            padding: clamp(4px, 1.5svh, 18px) 0 clamp(4px, 1.2svh, 10px);
          }
          .wm-weekly-digs-onboarding__group {
            align-content: center;
            text-align: center;
            gap: clamp(12px, 2svh, 22px);
            min-height: 0;
            height: 100%;
          }
          .wm-weekly-digs-onboarding__group--intro {
            align-content: center;
          }
          .wm-weekly-digs-onboarding__group--intro .wm-weekly-digs-onboarding__intro-card {
            transform: translateY(-3%);
          }
          .wm-weekly-digs-onboarding__intro-card strong {
            font-size: clamp(2.25rem, 8.8vw, 2.95rem);
            max-width: 10em;
          }
          .wm-weekly-digs-onboarding__intro-card p {
            font-size: clamp(0.96rem, 3.7vw, 1.12rem);
          }
          .wm-weekly-digs-onboarding__group-head {
            justify-items: center;
            gap: 6px;
          }
          .wm-weekly-digs-onboarding__group-head span {
            font-size: clamp(0.86rem, 3vw, 1rem);
            color: var(--wm-digs-tan);
          }
          .wm-weekly-digs-onboarding__group h3 {
            font-size: clamp(2rem, 7.8vw, 2.55rem);
            max-width: 10em;
          }
          .wm-weekly-digs-onboarding__group p {
            font-size: clamp(0.98rem, 3.65vw, 1.14rem);
          }
          .wm-weekly-digs-onboarding__pills {
            align-self: stretch;
            min-height: min(24svh, 190px);
            max-height: min(34svh, 280px);
            gap: clamp(8px, 2.2vw, 12px);
            padding-top: 2px;
            padding-bottom: 22px;
          }
          .wm-weekly-digs-onboarding__pills.is-dense {
            gap: clamp(7px, 1.8vw, 10px);
          }
          .wm-weekly-digs-pill {
            min-height: clamp(40px, 8.8vw, 50px);
            padding: 0 clamp(15px, 4.4vw, 24px);
            font-size: clamp(0.96rem, 3.75vw, 1.1rem);
            border-width: 2.5px;
          }
          .wm-weekly-digs-onboarding__pills.is-dense .wm-weekly-digs-pill {
            min-height: clamp(34px, 7.7vw, 42px);
            padding: 0 clamp(12px, 3.7vw, 18px);
            font-size: clamp(0.84rem, 3.35vw, 0.98rem);
            border-width: 2px;
          }
          .wm-weekly-digs-onboarding__footer {
            align-self: end;
            margin-top: 0;
            padding-top: 0;
            padding-bottom: 0;
            width: 100%;
          }
          .wm-weekly-digs-onboarding__actions {
            width: 100%;
          }
          .wm-weekly-digs-onboarding__submit {
            width: 100%;
            min-width: 0;
            max-width: none;
            min-height: clamp(46px, 10vw, 56px);
            font-size: 0.9rem;
          }
          .wm-weekly-digs-onboarding__back:not([hidden]) {
            width: 100%;
            min-width: 0;
            max-width: none;
            min-height: clamp(46px, 10vw, 56px);
            flex: 0 0 auto;
          }
          .wm-weekly-digs-onboarding__back:not([hidden]) + .wm-weekly-digs-onboarding__submit {
            flex: 0 0 auto;
          }
        }
        @media (max-width: 430px) and (max-height: 760px) {
          html.wm-weekly-digs-onboarding-active #endOfFeedMessage {
            height: var(--wm-weekly-digs-message-h, calc(100svh - 196px)) !important;
            height: var(--wm-weekly-digs-message-h, calc(100dvh - 196px)) !important;
          }
          .wm-weekly-digs-onboarding {
            height: 100%;
            min-height: 0;
            grid-template-rows: minmax(0, 1fr) auto;
            padding-left: 18px;
            padding-right: 18px;
            padding-bottom: 18px;
          }
          .wm-weekly-digs-onboarding__intro-card {
            gap: 12px;
          }
          .wm-weekly-digs-onboarding__intro-card strong {
            font-size: 1.95rem;
          }
          .wm-weekly-digs-onboarding__intro-card p {
            font-size: 0.9rem;
          }
          .wm-weekly-digs-onboarding__stage {
            padding: clamp(4px, 1.6svh, 14px) 0 6px;
            min-height: 0;
          }
          .wm-weekly-digs-onboarding__group {
            gap: 9px;
          }
          .wm-weekly-digs-onboarding__group h3 {
            font-size: 1.48rem;
          }
          .wm-weekly-digs-onboarding__group p {
            font-size: 0.88rem;
          }
          .wm-weekly-digs-pill {
            min-height: 36px;
            padding: 0 13px;
            font-size: 0.86rem;
          }
          .wm-weekly-digs-onboarding__pills.is-dense .wm-weekly-digs-pill {
            min-height: 32px;
            padding: 0 10px;
            font-size: 0.8rem;
          }
          .wm-weekly-digs-onboarding__pills {
            min-height: min(22svh, 160px);
            max-height: min(31svh, 230px);
            padding-bottom: 20px;
          }
          .wm-weekly-digs-onboarding__back,
          .wm-weekly-digs-onboarding__submit {
            min-height: 42px;
          }
        }
        @media (min-width: 760px) {
          html.wm-weekly-digs-onboarding-active #endOfFeedMessage {
            height: calc(100svh - 188px) !important;
          }
          .wm-weekly-digs-onboarding {
            width: min(100%, 820px);
            height: 100%;
            min-height: 0;
            margin-top: 0;
            padding: 0 24px 46px;
          }
          .wm-weekly-digs-onboarding__kicker {
            display: none;
          }
          .wm-weekly-digs-onboarding__stage {
            max-height: none;
            min-height: 0;
            align-items: center;
            padding: clamp(26px, 3.2vw, 42px);
          }
          .wm-weekly-digs-onboarding__group {
            grid-template-columns: 1fr;
            grid-template-areas:
              "head"
              "pills";
            justify-items: center;
            align-content: center;
            gap: clamp(18px, 2.2vw, 28px);
            text-align: center;
          }
          .wm-weekly-digs-onboarding__group--intro {
            grid-template-areas: none;
          }
          .wm-weekly-digs-onboarding__intro-card strong {
            font-size: clamp(2.8rem, 4.2vw, 4.4rem);
          }
          .wm-weekly-digs-onboarding__group-head {
            grid-area: head;
            justify-items: center;
            text-align: center;
          }
          .wm-weekly-digs-onboarding__group h3 {
            font-size: clamp(1.85rem, 3vw, 2.65rem);
            max-width: 11em;
          }
          .wm-weekly-digs-onboarding__group p {
            font-size: clamp(1.02rem, 1.4vw, 1.28rem);
          }
          .wm-weekly-digs-onboarding__pills {
            grid-area: pills;
            max-width: 720px;
            gap: 14px;
          }
          .wm-weekly-digs-pill {
            min-height: 48px;
            padding: 0 24px;
            font-size: 1.04rem;
          }
          .wm-weekly-digs-onboarding__footer {
            justify-content: center;
            margin-left: 0;
            margin-right: 0;
            text-align: center;
          }
          .wm-weekly-digs-onboarding__actions {
            justify-content: center;
          }
          .wm-weekly-digs-onboarding__submit {
            min-width: 190px;
          }
        }
      `;
      document.head.appendChild(style);
    }

    const message = document.getElementById('endOfFeedMessage');
    const loading = document.getElementById('loadingIndicator');
    if (loading) loading.style.display = 'none';
    if (!message) return;

    message.innerHTML = wmCustomerIsLoggedIn()
      ? wmWeeklyDigsOnboardingMarkup()
      : `
        <div class="wm-weekly-digs-empty">
          <strong>Please sign in to access your Weekly Digs.</strong>
          <a href="/customer_authentication/login?return_to=${encodeURIComponent(window.location.pathname + window.location.search)}">Sign in</a>
        </div>
      `;
    message.style.display = 'block';
    wmInstallWeeklyDigsOnboarding();
    const root = message.querySelector('[data-wm-weekly-onboarding]');
    if (root) wmRenderWeeklyDigsOnboardingStep(root);
    wmSyncWeeklyDigsOnboardingViewport();
    setTimeout(wmSyncWeeklyDigsOnboardingViewport, 250);
  }

  function wmShowWeeklyDigsNoProducts() {
    if (!WM_IS_WEEKLY_DIGS_FEED) return;
    document.querySelector('[data-wm-weekly-digs-fallback-notice]')?.remove();
    window.WM_WEEKLY_DIGS_ONBOARDING_ACTIVE = false;
    document.documentElement.classList.remove('wm-weekly-digs-onboarding-active');
    wmShowWeeklyDigsNotReady();
    window.WM_WEEKLY_DIGS_ONBOARDING_ACTIVE = false;
    document.documentElement.classList.remove('wm-weekly-digs-onboarding-active');

    const message = document.getElementById('endOfFeedMessage');
    const loading = document.getElementById('loadingIndicator');
    if (loading) loading.style.display = 'none';
    if (!message) return;

    message.innerHTML = `
      <div class="wm-weekly-digs-empty">
        <strong>We're running low on close matches.</strong>
        <span>Keep digging for now while we add more records around your usual style.</span>
        <a href="/collections/all-records">Keep digging</a>
      </div>
    `;
    message.style.display = 'block';
  }

  function wmEnsureWeeklyDigsFallbackNotice() {
    document.querySelector('[data-wm-weekly-digs-fallback-notice]')?.remove();
  }

  function wmApplyRecommendedOrder(source, ranked) {
	    if (WM_IS_WEEKLY_DIGS_FEED && ranked.length) {
	      window.WM_WEEKLY_DIGS_ONBOARDING_ACTIVE = false;
	      document.documentElement.classList.remove('wm-weekly-digs-onboarding-active');
	      document.documentElement.classList.remove('wm-weekly-digs-pending');
	      wmEnsureWeeklyDigsFallbackNotice();
	    }

    const byHandle = new Map(source.map(item => [wmNormalizeHandle(item), item]).filter(pair => pair[0]));
    const used = new Set();
    const ordered = [];

    ranked.forEach((recommendation, index) => {
      const item = byHandle.get(recommendation.handle);
      if (!item || used.has(recommendation.handle)) return;

      used.add(recommendation.handle);
      ordered.push({
        ...item,
        wm_recommendation: {
          rank: index + 1,
          score: recommendation.score,
          raw_score: recommendation.raw_score,
          contrast_factor: recommendation.contrast_factor,
          fatigue_factor: recommendation.fatigue_factor,
          archive_age_days: recommendation.archive_age_days,
          archive_boost: recommendation.archive_boost,
          branch_score: recommendation.branch_score,
          weekly_digs_tier: recommendation.weekly_digs_tier || '',
          weekly_digs_history_repeat: recommendation.weekly_digs_history_repeat === true,
          weekly_digs_fallback: recommendation.weekly_digs_fallback === true,
          blend_source: recommendation.blend_source || '',
          reason_codes: recommendation.reason_codes || []
        }
      });
    });

    if (!WM_IS_WEEKLY_DIGS_FEED) {
      source.forEach(item => {
        const handle = wmNormalizeHandle(item);
        if (!handle || used.has(handle)) return;
        ordered.push(item);
      });
    }

    window.WM_ACTIVE_COLLECTION_INDEX = ordered;
    window.WM_INDEX_CURSOR = 0;
    window.dispatchEvent(new CustomEvent('wm:recommendations-ready', {
      detail: { count: ordered.length, personalizedCount: ranked.length }
    }));

    if (
      WM_IS_WEEKLY_DIGS_FEED &&
      (window.WM_RECOMMENDATIONS_STATUS === 'not_ready' || window.WM_RECOMMENDATIONS_STATUS === 'login_required')
    ) {
      wmShowWeeklyDigsNotReady();
    } else if (WM_IS_WEEKLY_DIGS_FEED && window.WM_RECOMMENDATIONS_STATUS === 'no_products') {
      wmShowWeeklyDigsNoProducts();
    }

    if (DEBUG_ENABLED && WM_IS_PERSONALIZED_FEED) {
      window.WM_RECOMMENDATIONS_DEBUG = {
        enabled: true,
        ranked: ordered.map(item => ({
          handle: wmNormalizeHandle(item),
          recommendation: item.wm_recommendation || null
        }))
      };

      setTimeout(() => wmApplyRecommendationDebugOverlay(document), 0);
      setTimeout(() => wmApplyRecommendationDebugOverlay(document), 500);
    }
  }

  function wmInstallForYouGridStyles() {
    if (!FOR_YOU_GRID_VIEW || document.getElementById('wmForYouGridStyles')) return;

    const style = document.createElement('style');
    style.id = 'wmForYouGridStyles';
    style.textContent = `
      html.wm-for-you-grid-view,
      html.wm-for-you-grid-view body {
        height: auto !important;
        min-height: 100% !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        background: #2B2424 !important;
      }
      html.wm-for-you-grid-view body {
        position: static !important;
        touch-action: auto !important;
      }
      html.wm-for-you-grid-view.wm-feed-lock,
      html.wm-for-you-grid-view body.wm-feed-lock {
        height: auto !important;
        min-height: 100% !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        position: static !important;
        overscroll-behavior-y: auto !important;
        touch-action: auto !important;
      }
      html.wm-for-you-grid-view main,
      html.wm-for-you-grid-view #MainContent,
      html.wm-for-you-grid-view .shopify-section {
        height: auto !important;
        min-height: 0 !important;
        overflow: visible !important;
        position: static !important;
        background: #2B2424 !important;
      }
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view body > header,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .site-header,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view #shopify-section-header,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-header"],
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .shopify-section-group-header-group,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-sections--"][id$="__header"],
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [data-section-type="header"] {
        position: sticky !important;
        top: 0 !important;
        z-index: 10050 !important;
        background: #EAB782 !important;
        background-color: #EAB782 !important;
        color: #2B2424 !important;
      }
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view body > header a,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view body > header button,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .site-header a,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .site-header button,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view #shopify-section-header a,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view #shopify-section-header button,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-header"] a,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-header"] button,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .shopify-section-group-header-group a,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .shopify-section-group-header-group button,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-sections--"][id$="__header"] a,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-sections--"][id$="__header"] button,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [data-section-type="header"] a,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [data-section-type="header"] button {
        color: #2B2424 !important;
      }
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view body > header svg,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .site-header svg,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view #shopify-section-header svg,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-header"] svg,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .shopify-section-group-header-group svg,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-sections--"][id$="__header"] svg,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [data-section-type="header"] svg {
        color: #2B2424 !important;
        stroke: currentColor !important;
      }
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view body {
        padding-top: var(--wm-weekly-digs-grid-header-offset, 0px) !important;
      }
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .section-site-header,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view #shopify-section-header,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id^="shopify-section-sections--"][id$="__header"] {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
        z-index: 10070 !important;
      }
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .menu-drawer,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .drawer,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .navigation-drawer,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .mobile-menu,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view .mobile-nav,
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [id*="menu-drawer"],
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [class*="menu-drawer"],
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [data-drawer],
      html.wm-for-you-grid-view.wm-weekly-digs-grid-view [data-menu-drawer] {
        z-index: 10060 !important;
      }
      html.wm-for-you-grid-view .sorting-bar {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        height: 104px !important;
        z-index: 50 !important;
        overflow: visible !important;
        padding: 2rem 0 2rem !important;
        box-sizing: border-box !important;
        background: #2B2424 !important;
      }
      html.wm-for-you-grid-view .sorting-bar-inner {
        display: grid !important;
        grid-template-columns: minmax(0, 230px) minmax(0, 230px) 46px !important;
        gap: 0.75rem !important;
        justify-content: center !important;
        align-items: center !important;
        width: min(100%, 560px) !important;
        max-width: min(100%, 560px) !important;
        padding: 0 !important;
        margin: 0 auto !important;
      }
      html.wm-for-you-grid-view #sortForm.sorting-form {
        display: contents !important;
      }
      html.wm-for-you-grid-view .sorting-bar .wm-select {
        width: 100% !important;
        max-width: none !important;
        flex: none !important;
        z-index: 51 !important;
      }
      html.wm-for-you-grid-view .sorting-bar .wm-select.is-open {
        z-index: 59 !important;
      }
      html.wm-for-you-grid-view .sorting-bar .wm-select__panel {
        z-index: 60 !important;
      }
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn {
        width: 44px !important;
        min-width: 44px !important;
        max-width: 44px !important;
        height: 38px !important;
        min-height: 38px !important;
        max-height: 38px !important;
        flex: 0 0 44px !important;
        margin: 0 !important;
        border-radius: 10px !important;
      }
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn,
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn.wm-is-active {
        background: #2B2424 !important;
        color: #FFF2E9 !important;
      }
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn {
        border-color: #FFF2E9 !important;
      }
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn:hover,
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn:focus-visible {
        background: #2B2424 !important;
        color: #FFF2E9 !important;
      }
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn svg,
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn.wm-is-active svg {
        width: 23px !important;
        height: 23px !important;
      }
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn .wm-grid-view-icon--filled rect {
        fill: currentColor !important;
        stroke: none !important;
      }
      html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn .wm-grid-view-icon--outline rect {
        fill: none !important;
        stroke: currentColor !important;
      }
      html.wm-for-you-grid-view #verticalSwipeContainer,
      html.wm-for-you-grid-view #loadingIndicator,
      html.wm-for-you-grid-view #endOfFeedMessage {
        display: none !important;
        pointer-events: none !important;
      }
      html.wm-for-you-grid-view body:has(#verticalSwipeContainer) footer,
      html.wm-for-you-grid-view body:has(#verticalSwipeContainer) .site-footer,
      html.wm-for-you-grid-view body:has(#verticalSwipeContainer) .footer,
      html.wm-for-you-grid-view body:has(#verticalSwipeContainer) [data-section-type="footer"],
      html.wm-for-you-grid-view body:has(#verticalSwipeContainer) [id^="shopify-section-footer"],
      html.wm-for-you-grid-view body:has(#verticalSwipeContainer) [id*="__footer"] {
        display: revert !important;
      }
      .wm-for-you-grid {
        position: relative !important;
        z-index: 1 !important;
        width: 100%;
        min-height: 60vh;
        display: block !important;
        margin-top: 0 !important;
        overflow: visible !important;
        overflow-x: hidden !important;
        padding-bottom: calc(110px + env(safe-area-inset-bottom));
        background: #2B2424 !important;
        color: #FFF2E9 !important;
      }
      .wm-for-you-grid__item,
      .wm-for-you-grid .product-tile {
        background: transparent !important;
      }
      .wm-for-you-grid a,
      .wm-for-you-grid .product-tile,
      .wm-for-you-grid .product-tile a,
      .wm-for-you-grid .product-tile span,
      .wm-for-you-grid .product-tile div,
      .wm-for-you-grid .product-title,
      .wm-for-you-grid .product-tile__title,
      .wm-for-you-grid .price,
      .wm-for-you-grid .money {
        color: #FFF2E9 !important;
      }
      .wm-for-you-grid__content {
        position: relative;
        z-index: 1;
        width: 100%;
        max-width: var(--max-site-width, 1600px);
        margin: 0 auto;
        padding-top: 0;
        padding-bottom: 2.5rem;
        overflow: visible !important;
      }
      .wm-for-you-grid__status {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 220px;
        padding: 2rem 1rem;
      }
      .wm-for-you-grid__status[hidden] {
        display: none !important;
      }
      .wm-feed-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 80px;
      }
      .wm-feed-loading .spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #eab782;
        border-top: 4px solid #cba957;
        border-radius: 50%;
        animation: wmFeedSpin 1s linear infinite;
      }
      @keyframes wmFeedSpin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .wm-for-you-grid__items {
        list-style: none;
        margin: 0;
        padding: 0;
        overflow: visible !important;
      }
      .wm-for-you-grid__items[hidden],
      .wm-for-you-grid__more-wrap[hidden] {
        display: none !important;
      }
      html.wm-for-you-grid-view .wm-for-you-grid [id^="sold-out-sticker"],
      html.wm-for-you-grid-view .wm-for-you-grid [class*="sold-out-sticker"],
      html.wm-for-you-grid-view .wm-for-you-grid [class*="sold_out"],
      html.wm-for-you-grid-view .wm-for-you-grid [data-static-id="sold-out"] {
        display: none !important;
      }
      html.wm-for-you-grid-view .wm-wishlist-cart-button {
        width: 100%;
        min-height: 38px;
        margin-top: calc(14px + var(--wm-atc-align-offset, 0px));
        border: 1.5px solid rgba(255, 242, 233, 0.9);
        border-radius: 8px;
        background: transparent;
        color: #FFF2E9;
        font: inherit;
        font-size: 0.72rem;
        line-height: 1;
        font-weight: 800;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        cursor: pointer;
        transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, opacity 160ms ease;
      }
      html.wm-for-you-grid-view .wm-wishlist-cart-button:hover,
      html.wm-for-you-grid-view .wm-wishlist-cart-button:focus-visible {
        background: #EAB782;
        border-color: #EAB782;
        color: #2B2424;
      }
      html.wm-for-you-grid-view .wm-wishlist-cart-button:disabled {
        cursor: default;
        opacity: 0.7;
      }
      html.wm-for-you-grid-view .wm-wishlist-cart-button.is-added {
        background: #EAB782;
        border-color: #EAB782;
        color: #2B2424;
      }
      html.wm-for-you-grid-view .wm-wishlist-cart-button.is-sold-out,
      html.wm-for-you-grid-view .wm-wishlist-cart-button.is-sold-out:hover,
      html.wm-for-you-grid-view .wm-wishlist-cart-button.is-sold-out:focus-visible {
        border-color: rgba(255, 242, 233, 0.38);
        background: transparent;
        color: rgba(255, 242, 233, 0.48);
        cursor: not-allowed;
        opacity: 1;
      }
      @media (max-width: 749px) {
        html.wm-for-you-grid-view .sorting-bar {
          height: auto !important;
          min-height: 0 !important;
          padding: 1.25rem 0 1.5rem !important;
        }
        html.wm-for-you-grid-view .sorting-bar-inner {
          display: block !important;
          width: 100% !important;
          max-width: var(--max-site-width, 1600px) !important;
          padding-left: var(--section-padding, 1.25rem) !important;
          padding-right: var(--section-padding, 1.25rem) !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }
        html.wm-for-you-grid-view .sorting-main {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) 40px !important;
          gap: 0.55rem !important;
          width: 100% !important;
          max-width: 100% !important;
          align-items: stretch !important;
        }
        html.wm-for-you-grid-view #sortForm.sorting-form {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
          gap: 0.55rem !important;
          width: 100% !important;
          min-width: 0 !important;
        }
        html.wm-for-you-grid-view .sorting-bar .wm-select__button {
          height: 40px !important;
          padding-left: 10px !important;
          padding-right: 10px !important;
        }
        html.wm-for-you-grid-view .wm-wishlist-cart-button {
          min-height: 36px;
          margin-top: calc(10px + var(--wm-atc-align-offset, 0px));
          font-size: 0.66rem;
          border-radius: 7px;
        }
        html.wm-for-you-grid-view .sorting-bar .wm-select__value,
        html.wm-for-you-grid-view .sorting-bar .wm-select__option-title {
          font-size: 0.76rem !important;
        }
        .wm-for-you-grid {
          margin-top: 0 !important;
        }
        html.wm-for-you-grid-view .sorting-bar .grid-view-btn.wm-view-toggle-btn {
          width: 44px !important;
          min-width: 44px !important;
          max-width: 44px !important;
          height: 38px !important;
          min-height: 38px !important;
          max-height: 38px !important;
          flex: 0 0 44px !important;
          border-radius: 10px !important;
        }
        .wm-for-you-grid__content {
          padding-top: 0 !important;
        }
      }
      .wm-for-you-grid__more-wrap {
        display: flex;
        justify-content: center;
        padding: 2.25rem 0 0;
        min-height: 72px;
      }
      .wm-for-you-grid__more-wrap:not(.wm-for-you-grid__more-wrap--fallback) {
        padding-top: 1rem;
      }
      .wm-for-you-grid__more-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 48px;
      }
      .wm-for-you-grid__more-spinner[hidden],
      .wm-for-you-grid__more-wrap--fallback .wm-for-you-grid__more-spinner {
        display: none !important;
      }
      .wm-for-you-grid__more-spinner .spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #eab782;
        border-top: 4px solid #cba957;
        border-radius: 50%;
        animation: wmFeedSpin 1s linear infinite;
      }
      .wm-for-you-grid__more {
        min-width: min(220px, 100%);
        min-height: 48px;
        border: 2px solid #FFF2E9;
        border-radius: 8px;
        background: #2B2424;
        color: #FFF2E9;
        padding: 0.65rem 1.35rem;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        font-weight: 800;
        line-height: 1;
        cursor: pointer;
      }
      .wm-for-you-grid__more-wrap:not(.wm-for-you-grid__more-wrap--fallback) .wm-for-you-grid__more {
        display: none;
      }
      .wm-for-you-grid__more:hover,
      .wm-for-you-grid__more:focus-visible {
        background: #FFF2E9;
        color: #2B2424;
      }
      .wm-for-you-grid__more[disabled] {
        opacity: 0.55;
        cursor: wait;
      }
      .wm-for-you-grid__more .wm-feed-loading {
        min-height: 0;
        height: 20px;
      }
      .wm-for-you-grid__more .wm-feed-loading .spinner {
        width: 20px;
        height: 20px;
        border-width: 3px;
      }
      html.wm-for-you-grid-view .wm-for-you-grid .wm-grid-audio-card .product-tile__featured-media {
        position: relative;
        overflow: hidden;
      }
      html.wm-for-you-grid-view .wm-grid-audio-overlay {
        position: absolute;
        inset: 0;
        z-index: 4;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF2E9;
        text-decoration: none;
        pointer-events: none;
        cursor: default;
      }
      html.wm-for-you-grid-view .wm-grid-audio-overlay__button {
        width: clamp(48px, 14%, 64px);
        aspect-ratio: 1;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border: 0;
        border-radius: 999px;
        background: rgba(0, 0, 0, 0.68);
        color: #FFF2E9;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.28);
        backdrop-filter: blur(3px);
        transform-origin: 50% 50%;
        transition: background 160ms ease, box-shadow 160ms ease;
        pointer-events: auto;
        cursor: pointer;
      }
      html.wm-for-you-grid-view .wm-grid-audio-overlay:hover .wm-grid-audio-overlay__button,
      html.wm-for-you-grid-view .wm-grid-audio-overlay:focus-visible .wm-grid-audio-overlay__button {
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.78);
        box-shadow: 0 12px 34px rgba(0, 0, 0, 0.34);
      }
      html.wm-for-you-grid-view .wm-grid-audio-overlay__icon {
        width: 52%;
        height: 52%;
        fill: currentColor;
      }
      html.wm-for-you-grid-view .wm-grid-audio-overlay__icon--pause,
      html.wm-for-you-grid-view .wm-grid-audio-card.is-grid-audio-playing .wm-grid-audio-overlay__icon--play {
        display: none;
      }
      html.wm-for-you-grid-view .wm-grid-audio-card.is-grid-audio-playing .wm-grid-audio-overlay__icon--pause {
        display: block;
      }
      html.wm-for-you-grid-view .wm-grid-swish-anchor {
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 20;
        width: 48px;
        height: 48px;
        min-width: 48px;
        min-height: 48px;
        border-radius: 999px !important;
        background: transparent !important;
        box-shadow: none !important;
        overflow: visible !important;
        pointer-events: auto;
      }
      html.wm-for-you-grid-view .wm-grid-swish-anchor .ajax-cart-form,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .add-to-cart,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .cart-text,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .view-product-button {
        display: none !important;
      }
      html.wm-for-you-grid-view .wm-grid-swish-anchor .button-group {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 0 !important;
        border-radius: 999px !important;
        background: transparent !important;
        box-shadow: none !important;
        overflow: visible !important;
      }
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button:hover,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button:focus,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button:focus-visible,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button:active {
        width: 38px !important;
        min-width: 38px !important;
        max-width: 38px !important;
        height: 38px !important;
        min-height: 38px !important;
        max-height: 38px !important;
        border: 1.5px solid rgba(255, 242, 233, 0.9) !important;
        border-radius: 999px !important;
        background-color: rgba(43, 36, 36, 0.72) !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
        background-size: 20px 20px !important;
        background-origin: padding-box !important;
        background-clip: padding-box !important;
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27none%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E") !important;
        color: #FFF2E9 !important;
        box-sizing: border-box !important;
        appearance: none !important;
        -webkit-appearance: none !important;
        position: relative !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 0 !important;
        line-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.28) !important;
  overflow: hidden !important;
  clip-path: inset(0 round 999px) !important;
  -webkit-clip-path: inset(0 round 999px) !important;
  filter: none !important;
  text-shadow: none !important;
  contain: paint;
}
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button.wk-selected,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button.wk-selected:hover,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button.wk-selected:focus,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button.wk-selected:focus-visible,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button.wk-selected:active {
        background-color: rgba(43, 36, 36, 0.72) !important;
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27%23FFF2E9%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E") !important;
        background-size: 20px 20px !important;
      }
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button::before,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button::after,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button *::before,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button *::after,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button svg,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button wk-icon,
      html.wm-for-you-grid-view .wm-grid-swish-anchor .wk-button > * {
        display: none !important;
        content: none !important;
      }
      .wm-grid-global-player {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 40;
        min-height: 86px;
        background: rgba(43, 36, 36, 0.94);
        color: #FFF2E9;
        box-shadow: inset 0 1px 0 rgba(255, 242, 233, 0.12), 0 -14px 34px rgba(0, 0, 0, 0.32);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        transform: translateY(105%);
        transition: transform 180ms ease;
        font-family: "Poppins", sans-serif;
        touch-action: pan-y;
      }
      .wm-grid-global-player.is-visible {
        transform: translateY(0);
      }
      .wm-grid-global-player__inner {
        position: relative;
        width: min(1180px, calc(100% - 28px));
        min-height: 86px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: minmax(0, 280px) auto minmax(220px, 1fr) auto;
        align-items: center;
        gap: 0.85rem;
        padding: 0.65rem 0;
      }
      .wm-grid-global-player__release {
        min-width: 0;
        display: grid;
        grid-template-columns: 48px minmax(0, 1fr);
        align-items: center;
        gap: 0.65rem;
        color: inherit;
        text-decoration: none;
      }
      .wm-grid-global-player__cover {
        width: 48px;
        height: 48px;
        object-fit: cover;
        border-radius: 4px;
        background: rgba(255, 242, 233, 0.08);
        border: 1px solid rgba(255, 242, 233, 0.28);
      }
      .wm-grid-global-player__text {
        min-width: 0;
      }
      .wm-grid-global-player__title,
      .wm-grid-global-player__track {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 0;
      }
      .wm-grid-global-player__title {
        font-size: 0.78rem;
        line-height: 1.15;
        font-weight: 800;
      }
      .wm-grid-global-player__track {
        margin-top: 0.12rem;
        font-size: 0.72rem;
        line-height: 1.15;
        color: rgba(255, 242, 233, 0.75);
      }
      .wm-grid-global-player__controls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.45rem;
        position: relative;
        z-index: 3;
      }
      .wm-grid-global-player__button,
      .wm-grid-global-player__wishlist-fallback {
        width: 40px;
        height: 40px;
        border: 1.5px solid rgba(255, 242, 233, 0.85);
        border-radius: 999px;
        background: transparent;
        color: #FFF2E9;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        line-height: 0;
        box-sizing: border-box;
        box-shadow: none;
        position: relative;
        z-index: 1;
        touch-action: manipulation;
      }
      .wm-grid-global-player__button--play,
      .wm-grid-global-player__button--play:hover,
      .wm-grid-global-player__button--play:focus-visible,
      .wm-grid-global-player__button--play:active {
        width: 48px;
        height: 48px;
        background: #E8BD84;
        border-color: #E8BD84;
        color: #2B2424;
        position: relative;
      }
      .wm-grid-global-player__button svg {
        width: 54%;
        height: 54%;
        display: block;
        flex: 0 0 auto;
        margin: auto;
        fill: currentColor;
      }
      .wm-grid-global-player__button--play svg {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: 0;
      }
      .wm-grid-global-player__icon--pause {
        display: none !important;
      }
      .wm-grid-global-player__icon--play {
        transform: translate(-48%, -50%);
      }
      .wm-grid-global-player__icon--pause {
        transform: translate(-50%, -50%);
      }
      .wm-grid-global-player.is-playing .wm-grid-global-player__icon--play {
        display: none !important;
      }
      .wm-grid-global-player.is-playing .wm-grid-global-player__icon--pause {
        display: block !important;
      }
      .wm-grid-global-player__timeline {
        min-width: 0;
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        align-items: center;
        gap: 0.55rem;
      }
      .wm-grid-global-player__time {
        min-width: 3.2rem;
        font-size: 0.7rem;
        color: rgba(255, 242, 233, 0.8);
        font-weight: 700;
        text-align: center;
      }
      .wm-grid-global-player__progress {
        width: 100%;
        min-height: 22px;
        display: flex;
        align-items: center;
        cursor: pointer;
        touch-action: none;
        user-select: none;
      }
      .wm-grid-global-player__progress-track {
        position: relative;
        width: 100%;
        height: 10px;
        border-radius: 999px;
        background: rgba(255, 242, 233, 0.24);
        overflow: visible;
      }
      .wm-grid-global-player__progress-fill {
        position: absolute;
        inset: 0 auto 0 0;
        width: 0%;
        border-radius: inherit;
        background: #E8BD84;
      }
      .wm-grid-global-player__progress-dot {
        position: absolute;
        left: 0%;
        top: 50%;
        width: 16px;
        height: 16px;
        border-radius: 999px;
        background: #E8BD84;
        border: 2px solid #FFF2E9;
        transform: translate(-50%, -50%);
      }
      .wm-grid-global-player__actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .wm-grid-global-player__wishlist-fallback {
        position: relative;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 24px 24px;
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27none%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E");
      }
      .wm-grid-global-player__wishlist-fallback.is-active {
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27%23FFF2E9%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E");
      }
      .wm-grid-global-player__wishlist-fallback svg {
        display: none;
      }
      .wm-wishlist-login-modal[hidden] {
        display: none !important;
      }
      .wm-wishlist-login-modal {
        position: fixed;
        inset: 0;
        z-index: 90;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        background: rgba(0, 0, 0, 0.68);
      }
      .wm-wishlist-login-modal__panel {
        width: min(520px, 100%);
        border: 2px solid #FFF2E9;
        border-radius: 14px;
        background: #2B2424;
        color: #FFF2E9;
        padding: 24px;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.38);
        font-family: "Poppins", sans-serif;
      }
      .wm-wishlist-login-modal__panel h2 {
        margin: 0 0 0.75rem;
        font-size: 1.25rem;
        text-transform: uppercase;
      }
      .wm-wishlist-login-modal__panel p {
        margin: 0 0 1.25rem;
      }
      .wm-wishlist-login-modal__actions {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 0.6rem;
      }
      .wm-wishlist-login-modal__button {
        min-height: 44px;
        border: 2px solid #FFF2E9;
        border-radius: 8px;
        padding: 0.65rem 0.85rem;
        font-weight: 800;
        text-transform: uppercase;
      }
      .wm-wishlist-login-modal__button--primary {
        background: #E8BD84;
        border-color: #E8BD84;
        color: #2B2424;
      }
      @media (max-width: 749px) {
        body.wm-grid-player-open {
          padding-bottom: 122px;
        }
        .wm-for-you-grid__content {
          padding-left: var(--section-padding, 1.25rem);
          padding-right: var(--section-padding, 1.25rem);
        }
        html.wm-for-you-grid-view .wm-grid-swish-anchor {
          width: 38px;
          height: 38px;
        }
        .wm-grid-global-player {
          min-height: 108px;
        }
        .wm-grid-global-player__inner {
          width: calc(100% - 20px);
          min-height: 108px;
          grid-template-columns: minmax(0, 1fr) 122px 36px;
          grid-template-areas:
            "release controls actions"
            "timeline timeline timeline";
          gap: 0.48rem 3px;
          padding: 0.56rem 0 0.62rem;
        }
        .wm-grid-global-player__release {
          grid-area: release;
          grid-template-columns: 38px minmax(0, 1fr);
          gap: 0.5rem;
          align-self: center;
          padding-bottom: 0;
        }
        .wm-grid-global-player__cover {
          width: 38px;
          height: 38px;
        }
        .wm-grid-global-player__title {
          font-size: 0.72rem;
          line-height: 1.12;
        }
        .wm-grid-global-player__track {
          font-size: 0.66rem;
          line-height: 1.12;
        }
        .wm-grid-global-player__controls {
          grid-area: controls;
          width: 122px;
          gap: 4px;
          justify-self: end;
        }
        .wm-grid-global-player__button,
        .wm-grid-global-player__wishlist-fallback {
          width: 36px;
          height: 36px;
        }
        .wm-grid-global-player__wishlist-fallback {
          background-size: 20px 20px;
        }
        .wm-grid-global-player__button--play,
        .wm-grid-global-player__button--play:hover,
        .wm-grid-global-player__button--play:focus-visible,
        .wm-grid-global-player__button--play:active {
          width: 42px;
          height: 42px;
        }
        .wm-grid-global-player__timeline {
          grid-area: timeline;
          grid-template-columns: 2.75rem minmax(0, 1fr) 2.75rem;
          min-height: 22px;
          gap: 0.38rem;
          z-index: 2;
        }
        .wm-grid-global-player__time {
          min-width: 2.75rem;
          font-size: 0.62rem;
        }
        .wm-grid-global-player__progress-track {
          height: 7px;
        }
        .wm-grid-global-player__actions {
          grid-area: actions;
          width: 36px;
          justify-content: flex-end;
          justify-self: end;
        }
        .wm-wishlist-login-modal {
          padding: 12px;
        }
        .wm-wishlist-login-modal__actions {
          grid-template-columns: 1fr;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function wmSyncWeeklyDigsGridHeaderOffset() {
    if (!FOR_YOU_GRID_VIEW || !WM_IS_WEEKLY_DIGS_FEED) return;

    const header = document.querySelector(
      '.section-site-header, #shopify-section-header, [id^="shopify-section-sections--"][id$="__header"]'
    );
    const height = header ? Math.ceil(header.getBoundingClientRect().height || header.offsetHeight || 0) : 0;
    document.documentElement.style.setProperty('--wm-weekly-digs-grid-header-offset', `${height}px`);
  }

  function wmBuildForYouGridToggleUrl(isGrid) {
    const params = new URLSearchParams(window.location.search);
    params.delete('wm_view');

    if (params.get('view') === 'grid') {
      params.delete('view');
    }

    if (!isGrid) {
      params.set('wm_view', 'grid');
    }

    const query = params.toString();
    return query ? `${window.location.pathname}?${query}` : window.location.pathname;
  }

  function wmSyncForYouGridToggle() {
    if (!WM_IS_PERSONALIZED_FEED) return;

    const button = document.querySelector('.sorting-bar .grid-view-btn.wm-view-toggle-btn');
    if (!button) return;

    button.href = wmBuildForYouGridToggleUrl(FOR_YOU_GRID_VIEW);
    button.classList.toggle('wm-is-active', FOR_YOU_GRID_VIEW);
    if (FOR_YOU_GRID_VIEW) {
      button.innerHTML = `
        <svg class="wm-grid-view-icon wm-grid-view-icon--filled" viewBox="0 0 24 24" width="23" height="23" aria-hidden="true" focusable="false" fill="none">
          <rect x="4.05" y="4.05" width="6.95" height="6.95" rx="1.3" fill="currentColor"></rect>
          <rect x="13" y="4.05" width="6.95" height="6.95" rx="1.3" fill="currentColor"></rect>
          <rect x="4.05" y="13" width="6.95" height="6.95" rx="1.3" fill="currentColor"></rect>
          <rect x="13" y="13" width="6.95" height="6.95" rx="1.3" fill="currentColor"></rect>
        </svg>
      `;
    }
    button.setAttribute(
      'aria-label',
      FOR_YOU_GRID_VIEW ? 'Switch to scroll feed' : 'Switch to grid view'
    );
    button.setAttribute(
      'title',
      FOR_YOU_GRID_VIEW ? 'Scroll feed' : 'Grid view'
    );
  }

  function wmStopForYouGridBackgroundMedia() {
    if (!FOR_YOU_GRID_VIEW) return;
    document.documentElement.classList.add('wm-for-you-grid-view');
    document.documentElement.classList.remove('wm-feed-lock', 'wm-prepinned', 'wm-shuffle-boot');
    document.body.classList.remove('wm-feed-lock');
    wmUnlockForYouGridPageScroll();
    document.querySelectorAll('audio, video').forEach((media) => {
      try {
        media.pause();
        media.autoplay = false;
        media.removeAttribute('autoplay');
      } catch (err) {
        // Ignore media elements owned by third-party scripts.
      }
    });
    document.querySelectorAll('#verticalSwipeContainer .is-playing, #verticalSwipeContainer .is-active, #verticalSwipeContainer .swiper-slide-active').forEach((el) => {
      el.classList.remove('is-playing');
    });
  }

  function wmUnlockForYouGridPageScroll() {
    if (!FOR_YOU_GRID_VIEW) return;

    const targets = [
      document.documentElement,
      document.body,
      document.querySelector('main'),
      document.getElementById('MainContent'),
      document.getElementById('wmForYouGrid')?.closest('.shopify-section')
    ].filter(Boolean);

    targets.forEach((el) => {
      el.classList?.remove?.('wm-feed-lock', 'wm-prepinned', 'wm-shuffle-boot');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', el === document.body || el === document.documentElement ? '100%' : '0', 'important');
      el.style.setProperty('overflow-y', el === document.body || el === document.documentElement ? 'auto' : 'visible', 'important');
      el.style.setProperty('overflow-x', 'hidden', 'important');
      el.style.setProperty('position', 'static', 'important');
      el.style.setProperty('touch-action', 'auto', 'important');
      el.style.setProperty('overscroll-behavior-y', 'auto', 'important');
    });

    document.querySelectorAll('#verticalSwipeContainer, #loadingIndicator, #endOfFeedMessage').forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function wmProtectForYouGridScrolling() {
    if (!FOR_YOU_GRID_VIEW) return;
    wmUnlockForYouGridPageScroll();
  }

  function wmBuildForYouGridShell() {
    let shell = document.getElementById('wmForYouGrid');
    if (shell) return shell;

    shell = document.createElement('div');
    shell.id = 'wmForYouGrid';
    shell.className = 'wm-for-you-grid relative grid';
    shell.setAttribute('data-color-scheme', '');
    shell.innerHTML = `
      <div class="wm-for-you-grid__content section-content relative z-10 mx-auto w-full max-w-site px-section pb-section-vertical-spacing pt-half-section-vertical-spacing">
        <div class="wm-for-you-grid__status"><div class="wm-feed-loading" aria-label="Loading"><div class="spinner"></div></div></div>
        <ul class="wm-for-you-grid__items grid gap-theme grid-cols-2 lg:grid-cols-4" hidden></ul>
        <div class="wm-for-you-grid__more-wrap" hidden>
          <div class="wm-for-you-grid__more-spinner" aria-label="Loading more recommendations" hidden><div class="spinner"></div></div>
          <button type="button" class="wm-for-you-grid__more">Load more</button>
        </div>
      </div>
    `;

    const sortingBar = document.querySelector('.sorting-bar');
    if (sortingBar) {
      sortingBar.insertAdjacentElement('afterend', shell);
    } else {
      document.body.appendChild(shell);
    }

    return shell;
  }

  async function wmFetchForYouGridTile(handle, index, item) {
    const url = `/products/${encodeURIComponent(handle)}?view=wm-rec-grid-tile&i=${encodeURIComponent(index)}`;
    const response = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error(`Tile failed: ${response.status}`);

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const tile = doc.querySelector('.wm-for-you-grid__item') || doc.body.firstElementChild;
    if (tile) {
      tile.setAttribute('data-wm-grid-preorder', wmForYouGridIndexItemIsPreorder(item) ? '1' : '0');
      const releaseDate = wmForYouGridPreorderReleaseDate(item);
      if (releaseDate) tile.setAttribute('data-wm-preorder-release-date', releaseDate);
    }
    return tile ? document.importNode(tile, true) : null;
  }

  function wmForYouGridIndexItemIsPreorder(item) {
    const rawTags = Array.isArray(item?.tags) ? item.tags : String(item?.tags || '').split(',');
    const tags = rawTags.map((tag) => String(tag || '').trim().toLowerCase());
    const inventoryPolicy = String(item?.inventory_policy || '').toLowerCase();
    const inventoryQuantity = Number(item?.inventory_quantity || 0);
    return item?.is_preorder === true || tags.includes('preorder') || (inventoryPolicy === 'continue' && inventoryQuantity <= 0);
  }

  function wmForYouGridPreorderReleaseDate(item) {
    return String(item?.preorder_release_date || '').trim();
  }

  async function wmResolveForYouGridPreorderReleaseDate(handle, button) {
    const existing = String(button?.dataset?.wmPreorderReleaseDate || '').trim();
    if (existing) return existing;
    if (!handle) return '';
    if (FOR_YOU_GRID_PREORDER_RELEASE_DATE_CACHE.has(handle)) {
      const cached = await FOR_YOU_GRID_PREORDER_RELEASE_DATE_CACHE.get(handle);
      if (cached && button) button.dataset.wmPreorderReleaseDate = cached;
      return cached;
    }

    const promise = (async () => {
      const productUrl = `/products/${encodeURIComponent(handle)}`;
      const urls = [`${productUrl}?view=ajax-card`, productUrl];
      for (const url of urls) {
        try {
          const response = await fetch(url, {
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) continue;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const input = doc.querySelector('input[name="properties[_wm_release_date]"]');
          const value = String(input?.value || input?.getAttribute('value') || '').trim();
          if (value) return value;
        } catch (err) {}
      }
      return '';
    })();

    FOR_YOU_GRID_PREORDER_RELEASE_DATE_CACHE.set(handle, promise);
    const resolved = await promise;
    if (resolved && button) button.dataset.wmPreorderReleaseDate = resolved;
    return resolved;
  }

  async function wmForYouGridProductJson(handle) {
    if (!handle) return null;
    if (FOR_YOU_GRID_PRODUCT_JSON_CACHE.has(handle)) return FOR_YOU_GRID_PRODUCT_JSON_CACHE.get(handle);
    const promise = fetch(`/products/${encodeURIComponent(handle)}.js`, {
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      if (!response.ok) throw new Error(`Product JSON failed for ${handle}: ${response.status}`);
      return response.json();
    });
    FOR_YOU_GRID_PRODUCT_JSON_CACHE.set(handle, promise);
    return promise;
  }

  async function wmResolveForYouGridVariantId(handle) {
    const product = await wmForYouGridProductJson(handle);
    const variant = product?.variants?.find((item) => item.available) ||
      product?.variants?.find((item) => wmForYouGridVariantIsPreorder(item)) ||
      product?.variants?.[0];
    return variant?.id ? String(variant.id) : '';
  }

  function wmForYouGridVariantIsPreorder(variant) {
    const policy = String(variant?.inventory_policy || '').toLowerCase();
    const quantity = Number(variant?.inventory_quantity ?? variant?.inventoryQuantity ?? 0);
    return policy === 'continue' && quantity <= 0;
  }

  function wmForYouGridProductIsPreorder(product) {
    const rawTags = Array.isArray(product?.tags) ? product.tags : String(product?.tags || '').split(',');
    const tags = rawTags.map((tag) => String(tag || '').trim().toLowerCase());
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return tags.includes('preorder') || variants.some(wmForYouGridVariantIsPreorder);
  }

  function wmForYouGridTileIsPreorder(product, tile) {
    return tile?.dataset?.wmGridPreorder === '1' || wmForYouGridProductIsPreorder(product);
  }

  function wmProductHasAvailableVariant(product) {
    if (wmForYouGridProductIsPreorder(product)) return true;
    if (!product?.variants?.length) return true;
    return product.variants.some((item) => item?.available !== false);
  }

  function wmSetForYouGridCartSoldOut(button) {
    if (!button) return;
    button.disabled = true;
    button.classList.add('is-sold-out');
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Sold out';
  }

  function wmForYouGridPreorderProperties(isPreorder, releaseDate = '') {
    if (!isPreorder) return undefined;
    const properties = { _wm_preorder: 'Yes' };
    const date = String(releaseDate || '').trim();
    if (date) properties._wm_release_date = date;
    return properties;
  }

  async function wmAddForYouGridVariantToCart(variantId, isPreorder = false, releaseDate = '') {
    if (!variantId) throw new Error('Missing variant ID');
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: wmForYouGridPreorderProperties(isPreorder, releaseDate)
        }]
      })
    });
    if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
    return response.json();
  }

  function wmRefreshForYouGridCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const count = cart?.item_count;
        const cartIcon = document.querySelector('#CartButton [x-text="$store.cart_count.count"]');
        if (cartIcon && typeof count === 'number') {
          cartIcon.textContent = String(count);
          cartIcon.style.display = count > 0 ? 'flex' : 'none';
          cartIcon.classList.add('cart-updated');
          setTimeout(() => cartIcon.classList.remove('cart-updated'), 800);
        }
        document.dispatchEvent(new CustomEvent('wm:wishlist-cart-added', { detail: { cart } }));
      })
      .catch(() => {});
  }

  function wmEnhanceForYouGridCartButtons(root) {
    if (!root) return;
    root.querySelectorAll('.wm-index-grid__item[data-product-handle]').forEach((tile) => {
      if (tile.dataset.wmGridCartEnhanced === '1') return;
      const handle = tile.dataset.productHandle || '';
      if (!handle) return;
      const details = tile.querySelector('.product-tile.mt-5') || tile.querySelector('.product-tile:not(.wm-grid-audio-card)') || tile;
      if (!details || details.querySelector('.wm-wishlist-cart-button')) return;
      details.classList.add('wm-wishlist-details');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'wm-wishlist-cart-button';
      button.dataset.wmGridCartHandle = handle;
      button.dataset.wmCartDefaultText = 'ADD TO CART';
      button.textContent = 'Add to cart';
      details.appendChild(button);
      tile.dataset.wmGridCartEnhanced = '1';
      if (tile.dataset.wmGridPreorder === '1') {
        button.classList.add('is-preorder');
        button.dataset.wmCartDefaultText = 'PRE-ORDER';
        if (tile.dataset.wmPreorderReleaseDate) button.dataset.wmPreorderReleaseDate = tile.dataset.wmPreorderReleaseDate;
        button.textContent = 'PRE-ORDER';
      }
      wmForYouGridProductJson(handle)
        .then((product) => {
          if (wmForYouGridTileIsPreorder(product, tile)) {
            button.classList.add('is-preorder');
            button.dataset.wmCartDefaultText = 'PRE-ORDER';
            button.textContent = 'PRE-ORDER';
          } else if (!wmProductHasAvailableVariant(product)) {
            wmSetForYouGridCartSoldOut(button);
          }
        })
        .catch(() => {});
    });
    wmScheduleForYouGridCartButtonAlignment(root);
  }

  let wmForYouGridCartAlignTimer = null;
  function wmScheduleForYouGridCartButtonAlignment(root) {
    clearTimeout(wmForYouGridCartAlignTimer);
    wmForYouGridCartAlignTimer = setTimeout(() => wmAlignForYouGridCartButtons(root), 80);
  }

  function wmAlignForYouGridCartButtons(root) {
    if (!root) return;
    const buttons = Array.from(root.querySelectorAll('.wm-wishlist-cart-button'));
    buttons.forEach((button) => button.style.removeProperty('--wm-atc-align-offset'));
    if (buttons.length < 2) return;

    const rows = new Map();
    buttons.forEach((button) => {
      const tile = button.closest('.wm-index-grid__item') || button.closest('li');
      if (!tile) return;
      const rowKey = Math.round(tile.getBoundingClientRect().top / 8) * 8;
      const row = rows.get(rowKey) || [];
      row.push({ button, top: button.getBoundingClientRect().top });
      rows.set(rowKey, row);
    });

    rows.forEach((row) => {
      if (row.length < 2) return;
      const targetTop = Math.max(...row.map((item) => item.top));
      row.forEach(({ button, top }) => {
        button.style.setProperty('--wm-atc-align-offset', `${Math.max(0, targetTop - top)}px`);
      });
    });
  }

  async function wmHandleForYouGridCartClick(button) {
    if (!button || button.disabled) return;
    const originalText = button.dataset.wmCartDefaultText || button.textContent;
    const handle = button.dataset.wmGridCartHandle || button.closest('[data-product-handle]')?.dataset.productHandle || '';
    button.disabled = true;
    button.classList.remove('is-added');
    button.textContent = 'Adding...';
    try {
      const variantId = await wmResolveForYouGridVariantId(handle);
      const isPreorder = button.classList.contains('is-preorder');
      const releaseDate = isPreorder ? await wmResolveForYouGridPreorderReleaseDate(handle, button) : '';
      await wmAddForYouGridVariantToCart(
        variantId,
        isPreorder,
        releaseDate
      );
      const payload = wmGetForYouGridPayloadFromNode(button);
      if (payload) {
        wmPostRecommendationEvent('/events', {
          event_type: 'add_to_cart',
          source: window.WM_FEED_SOURCE || 'collection',
          ...payload
        });
      }
      wmRefreshForYouGridCartCount();
      button.classList.add('is-added');
      button.textContent = 'Added';
      setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-added');
        button.textContent = originalText || 'ADD TO CART';
      }, 1800);
    } catch (err) {
      button.disabled = false;
      button.textContent = 'Try again';
      setTimeout(() => {
        button.textContent = originalText || 'ADD TO CART';
      }, 1800);
    }
  }

  function wmInstallForYouGridPlayer(shell) {
    if (!FOR_YOU_GRID_VIEW || !shell || shell.dataset.wmForYouGridPlayer === '1') return;
    shell.dataset.wmForYouGridPlayer = '1';

    const audio = new Audio();
    audio.preload = 'none';
    audio.playsInline = true;

    let activeOverlay = null;
    let activeCard = null;
    let activePlayButton = null;
    let activeTrackIndex = 0;
    let activeTracks = [];
    let activeTitles = [];
    let activeSrc = '';
    let progressDragActive = false;
    let playerSwipeStartX = 0;
    let playerSwipeStartY = 0;
    let playerSwipeStartTime = 0;

    const player = document.createElement('div');
    player.className = 'wm-grid-global-player';
    player.setAttribute('aria-live', 'polite');
    player.innerHTML = `
      <div class="wm-grid-global-player__inner">
        <a class="wm-grid-global-player__release" data-wm-grid-player-link href="#">
          <img class="wm-grid-global-player__cover" data-wm-grid-player-cover alt="">
          <div class="wm-grid-global-player__text">
            <span class="wm-grid-global-player__title" data-wm-grid-player-release>Preview</span>
            <span class="wm-grid-global-player__track" data-wm-grid-player-track>Track 1</span>
          </div>
        </a>

        <div class="wm-grid-global-player__controls">
          <button class="wm-grid-global-player__button" type="button" data-wm-grid-player-prev aria-label="Previous track">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M6 12l11-7v14L6 12Z"></path><rect x="4" y="5" width="2" height="14"></rect></svg>
          </button>
          <button class="wm-grid-global-player__button wm-grid-global-player__button--play" type="button" data-wm-grid-player-play aria-label="Play">
            <svg class="wm-grid-global-player__icon--play" viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M8 5v14l11-7L8 5z"></path></svg>
            <svg class="wm-grid-global-player__icon--pause" viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"></path></svg>
          </button>
          <button class="wm-grid-global-player__button" type="button" data-wm-grid-player-next aria-label="Next track">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M18 12 7 19V5l11 7Z"></path><rect x="18" y="5" width="2" height="14"></rect></svg>
          </button>
        </div>

        <div class="wm-grid-global-player__timeline">
          <span class="wm-grid-global-player__time" data-wm-grid-player-current>0:00</span>
          <div class="wm-grid-global-player__progress" data-wm-grid-player-progress role="slider" tabindex="0" aria-label="Audio progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
            <div class="wm-grid-global-player__progress-track">
              <span class="wm-grid-global-player__progress-fill" data-wm-grid-player-progress-fill></span>
              <span class="wm-grid-global-player__progress-dot" data-wm-grid-player-progress-dot></span>
            </div>
          </div>
          <span class="wm-grid-global-player__time" data-wm-grid-player-duration>0:00</span>
        </div>

        <div class="wm-grid-global-player__actions">
          <button class="wm-grid-global-player__wishlist-fallback" type="button" data-wm-grid-player-wishlist aria-label="Add to wishlist">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 0 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z"></path></svg>
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(player);

    const coverEl = player.querySelector('[data-wm-grid-player-cover]');
    const releaseEl = player.querySelector('[data-wm-grid-player-release]');
    const trackEl = player.querySelector('[data-wm-grid-player-track]');
    const productLinkEl = player.querySelector('[data-wm-grid-player-link]');
    const playButton = player.querySelector('[data-wm-grid-player-play]');
    const prevButton = player.querySelector('[data-wm-grid-player-prev]');
    const nextButton = player.querySelector('[data-wm-grid-player-next]');
    const progressEl = player.querySelector('[data-wm-grid-player-progress]');
    const fillEl = player.querySelector('[data-wm-grid-player-progress-fill]');
    const dotEl = player.querySelector('[data-wm-grid-player-progress-dot]');
    const currentTimeEl = player.querySelector('[data-wm-grid-player-current]');
    const durationEl = player.querySelector('[data-wm-grid-player-duration]');
    const wishlistButton = player.querySelector('[data-wm-grid-player-wishlist]');

    function parseJsonAttribute(el, name) {
      try {
        const value = el.getAttribute(name);
        return value ? JSON.parse(value) : [];
      } catch (err) {
        return [];
      }
    }

    function formatTime(value) {
      const seconds = Math.max(0, Math.floor(Number(value) || 0));
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${String(secs).padStart(2, '0')}`;
    }

    function setProgress(percent) {
      const safePercent = Math.max(0, Math.min(100, Number(percent) || 0));
      if (fillEl) fillEl.style.width = `${safePercent}%`;
      if (dotEl) dotEl.style.left = `${safePercent}%`;
      if (progressEl) progressEl.setAttribute('aria-valuenow', String(Math.round(safePercent)));
    }

    function scheduleWishlistRefresh() {
      clearTimeout(window.__wmForYouGridWishlistRefreshTimer);
      window.__wmForYouGridWishlistRefreshTimer = setTimeout(() => {
        const refresh = [
          window.WishlistKing?.buttons?.refresh ? () => window.WishlistKing.buttons.refresh() : null,
          window.WishlistKing?.buttons?.render ? () => window.WishlistKing.buttons.render() : null,
          window.WishlistKing?.refresh ? () => window.WishlistKing.refresh() : null,
          window.WishlistKing?.render ? () => window.WishlistKing.render() : null,
          window.WishlistKing?.scan ? () => window.WishlistKing.scan() : null
        ].find(Boolean);
        try {
          const result = refresh?.();
          if (result && typeof result.catch === 'function') result.catch(() => {});
        } catch (err) {}
      }, 120);
    }

    function showWishlistLoginModal() {
      let modal = document.getElementById('wmWishlistLoginModal');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'wmWishlistLoginModal';
        modal.className = 'wm-wishlist-login-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-labelledby', 'wmWishlistLoginTitle');
        modal.innerHTML = `
          <div class="wm-wishlist-login-modal__panel">
            <h2 id="wmWishlistLoginTitle">Save your wishlist</h2>
            <p>Sign in or create an account to save your wishlist and access it whenever you come back.</p>
            <div class="wm-wishlist-login-modal__actions">
              <button type="button" class="wm-wishlist-login-modal__button wm-wishlist-login-modal__button--primary" data-wm-login-action="login">Log in</button>
              <button type="button" class="wm-wishlist-login-modal__button wm-wishlist-login-modal__button--secondary" data-wm-login-action="signup">Sign up</button>
              <button type="button" class="wm-wishlist-login-modal__button wm-wishlist-login-modal__button--ghost" data-wm-login-action="close">Dismiss</button>
            </div>
          </div>
        `;
        document.body.appendChild(modal);
        modal.addEventListener('click', (event) => {
          if (event.target === modal || event.target.closest('[data-wm-login-action="close"]')) {
            modal.hidden = true;
            return;
          }
          const action = event.target.closest('[data-wm-login-action]')?.getAttribute('data-wm-login-action');
          if (!action) return;
          const returnUrl = new URL(window.location.href);
          returnUrl.searchParams.set('wm_return', '1');
          const returnTo = encodeURIComponent(returnUrl.pathname + returnUrl.search);
          window.location.href = '/customer_authentication/login?return_to=' + returnTo;
        });
      }
      modal.hidden = false;
    }

    function activeTileWishlistButton() {
      if (!activeCard) return null;
      return activeCard.querySelector('.wm-grid-swish-anchor .wk-button');
    }

    function tileWishlistButtonFromEvent(event) {
      const button = event.target.closest?.('.wm-grid-swish-anchor .wk-button');
      if (button) return button;
      return event.target.closest?.('.wm-grid-swish-anchor')?.querySelector('.wk-button') || null;
    }

    function wishlistApi() {
      return window.WishlistKing?._apis?.wishlist || null;
    }

    async function clearWishlistApiCache(api = wishlistApi()) {
      if (!api?.clearCache) return;
      try {
        await api.clearCache();
      } catch (err) {}
    }

    async function loadWishlistItems() {
      const api = wishlistApi();
      if (!api?.loadWishlist) return [];
      const result = await api.loadWishlist({ wishlistId: 'mine' });
      return (
        result?.wishlist?.items ||
        result?.items ||
        result?.products ||
        []
      );
    }

    function wishlistProductFromCard(card) {
      const tile = card?.closest?.('[data-product-handle]');
      const handle = String(tile?.dataset?.productHandle || tile?.getAttribute('data-product-handle') || '').trim();
      const productId = String(
        tile?.dataset?.productId ||
        tile?.getAttribute('data-product-id') ||
        card?.querySelector?.('[data-wm-grid-audio]')?.getAttribute('data-wm-grid-audio-product-id') ||
        ''
      ).trim();
      return handle || productId ? { handle, productId } : null;
    }

    function wishlistItemMatches(item, product) {
      if (!item || !product) return false;
      const itemHandle = String(
        item?.product?.handle ||
        item?.handle ||
        item?.product_handle ||
        ''
      ).trim();
      const itemProductId = String(
        item?.product_id ||
        item?.productId ||
        item?.product?.id ||
        item?.product?.product_id ||
        ''
      ).trim();
      return (
        (!!product.handle && itemHandle === product.handle) ||
        (!!product.productId && itemProductId === product.productId)
      );
    }

    function wishlistItemId(item) {
      return String(item?.id || item?.wishlist_item_id || item?.wishlistItemId || '').trim();
    }

    function wishlistItemForProduct(items, product) {
      if (!Array.isArray(items) || !product) return null;
      return items.find((item) => wishlistItemMatches(item, product)) || null;
    }

    async function resolveWishlistProductId(product) {
      const directId = String(product?.productId || '').trim();
      if (directId) return directId;
      const handle = String(product?.handle || '').trim();
      if (!handle) return '';
      try {
        const productJson = await wmForYouGridProductJson(handle);
        return String(productJson?.id || '').trim();
      } catch (err) {
        return '';
      }
    }

    async function mutateWishlistDirect(product, shouldAdd) {
      const api = wishlistApi();
      if (!api) return false;
      await clearWishlistApiCache(api);

      if (shouldAdd) {
        if (!api.addItem) return false;
        const productId = await resolveWishlistProductId(product);
        if (!productId) return false;
        await api.addItem({
          wishlistId: 'mine',
          productId: /^\d+$/.test(productId) ? Number(productId) : productId
        });
        await clearWishlistApiCache(api);
        return true;
      }

      if (!api.removeItem) return false;
      const items = await loadWishlistItems();
      const itemId = wishlistItemId(wishlistItemForProduct(items, product));
      if (!itemId) return false;
      await api.removeItem({
        wishlistId: 'mine',
        wishlistItemId: itemId
      });
      await clearWishlistApiCache(api);
      return true;
    }

    function syncTileWishlistButtons(product, isActive) {
      if (!product?.handle && !product?.productId) return;
      shell.querySelectorAll('[data-product-handle]').forEach((tile) => {
        const handle = String(tile.dataset.productHandle || tile.getAttribute('data-product-handle') || '').trim();
        const productId = String(tile.dataset.productId || tile.getAttribute('data-product-id') || '').trim();
        const matchesHandle = !!product.handle && handle === product.handle;
        const matchesProductId = !!product.productId && productId === product.productId;
        if (!matchesHandle && !matchesProductId) return;
        tile.querySelectorAll('.wm-grid-swish-anchor .wk-button').forEach((button) => {
          button.classList.toggle('wk-selected', !!isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
        });
      });
    }

    function visibleWishlistCounters() {
      return Array.from(document.querySelectorAll('.wk-counter, [data-wk-counter], [data-wishlist-count]'));
    }

    function currentWishlistCounterValue() {
      for (const counter of visibleWishlistCounters()) {
        const value = Number(String(counter.textContent || counter.getAttribute('data-count') || '').replace(/[^\d]/g, ''));
        if (Number.isFinite(value)) return value;
      }
      return null;
    }

    function updateWishlistCounters(count) {
      const safeCount = Math.max(0, Number(count) || 0);
      visibleWishlistCounters().forEach((counter) => {
        counter.textContent = String(safeCount);
        counter.setAttribute('data-count', String(safeCount));
        counter.style.display = safeCount > 0 ? '' : counter.style.display;
      });
    }

    function updateWishlistCounter(delta) {
      const currentCount = currentWishlistCounterValue();
      if (currentCount === null) return;
      updateWishlistCounters(currentCount + delta);
    }

    async function reconcileWishlistAfterClick(product, expectedState = null) {
      if (!product?.handle && !product?.productId) return false;
      const delays = [1200];
      let latestState = expectedState;

      for (const delay of delays) {
        await new Promise((resolve) => setTimeout(resolve, delay));
        let items = null;
        try {
          items = await loadWishlistItems();
        } catch (err) {
          items = null;
        }
        if (!Array.isArray(items)) continue;
        const isActive = items.some((item) => wishlistItemMatches(item, product));
        latestState = isActive;
        const isFinalCheck = delay === delays[delays.length - 1];
        if (expectedState !== null && isActive !== expectedState && !isFinalCheck) continue;
        updateWishlistCounters(items.length);
        syncTileWishlistButtons(product, isActive);
        if (activeCard && wishlistItemMatches(wishlistProductFromCard(activeCard), product)) {
          setGlobalWishlistState(isActive);
        }
        if (expectedState === null || isActive === expectedState) return isActive;
      }

      syncTileWishlistButtons(product, !!latestState);
      return !!latestState;
    }

    async function currentWishlistStateForProduct(product, fallbackButton = null) {
      if (!product?.handle && !product?.productId) return false;
      try {
        const items = await loadWishlistItems();
        if (Array.isArray(items)) {
          updateWishlistCounters(items.length);
          return items.some((item) => wishlistItemMatches(item, product));
        }
      } catch (err) {}
      return wishlistButtonIsActive(fallbackButton);
    }

    const wishlistClickPendingByProduct = new Set();
    const wishlistOptimisticStateByProduct = new Map();

    function wmCustomerIsLoggedIn() {
      if (window.WM_CUSTOMER_LOGGED_IN === true) return true;
      if (window.WM_CUSTOMER_AUTH_STATUS && window.WM_CUSTOMER_AUTH_STATUS.authenticated === true) return true;
      try {
        return sessionStorage.getItem('wm_customer_auth_confirmed') === '1';
      } catch (e) {
        return false;
      }
    }

    function handleTileWishlistClick(button, event) {
      if (!button || !event?.isTrusted) return false;
      if (!wmCustomerIsLoggedIn()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showWishlistLoginModal();
        return true;
      }

      const card = button.closest('.wm-grid-audio-card');
      const product = wishlistProductFromCard(card);
      const productKey = product?.handle || product?.productId || '';
      if (!productKey || wishlistClickPendingByProduct.has(productKey)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return true;
      }

      const beforeState = wishlistOptimisticStateByProduct.has(productKey)
        ? wishlistOptimisticStateByProduct.get(productKey)
        : wishlistButtonIsActive(button);
      const nextState = !beforeState;
      const shouldForwardClick = !button.contains(event.target);
      const canUseDirectWishlist = !!wishlistApi()?.addItem && !!wishlistApi()?.removeItem;
      if (shouldForwardClick || canUseDirectWishlist) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      wishlistClickPendingByProduct.add(productKey);
      wishlistOptimisticStateByProduct.set(productKey, nextState);
      updateWishlistCounter(nextState ? 1 : -1);
      if (activeCard === card) setGlobalWishlistState(nextState);
      if (nextState) {
        const payload = wmGetForYouGridPayloadFromNode(card);
        if (payload) {
          wmPostRecommendationEvent('/events', {
            event_type: 'wishlist_add',
            source: window.WM_FEED_SOURCE || 'collection',
            ...payload
          });
        }
      }

      if (shouldForwardClick && !canUseDirectWishlist) button.click();
      setTimeout(() => {
        syncTileWishlistButtons(product, nextState);
        if (activeCard === card) setGlobalWishlistState(nextState);
      }, 0);

      const directMutation = canUseDirectWishlist
        ? mutateWishlistDirect(product, nextState).catch(() => false)
        : Promise.resolve(false);
      let handledDirectWishlistMutation = false;

      setTimeout(() => {
        directMutation
          .then((handledDirectly) => {
            handledDirectWishlistMutation = handledDirectly;
            if (handledDirectly) return { actualState: nextState, handledDirectly };
            if (!handledDirectly && canUseDirectWishlist && button.isConnected) button.click();
            return reconcileWishlistAfterClick(product, nextState)
              .then((actualState) => ({ actualState, handledDirectly }));
          })
          .then(({ actualState, handledDirectly }) => {
            if (handledDirectly) return null;
            if (actualState === nextState || !button.isConnected) return null;
            button.click();
            return reconcileWishlistAfterClick(product, nextState);
          })
          .catch(() => {})
          .finally(() => {
            wishlistClickPendingByProduct.delete(productKey);
            wishlistOptimisticStateByProduct.delete(productKey);
            if (!handledDirectWishlistMutation) scheduleWishlistRefresh();
          });
      }, 650);

      return shouldForwardClick || canUseDirectWishlist;
    }

    function wishlistButtonIsActive(button) {
      if (!button) return false;
      const state = [
        button.getAttribute('aria-pressed'),
        button.getAttribute('aria-label'),
        button.getAttribute('title'),
        button.getAttribute('data-state'),
        button.textContent,
        button.className
      ].join(' ').toLowerCase();
      return state.includes('true') || state.includes('remove') || state.includes('added') || state.includes('selected') || state.includes('active') || state.includes('in wishlist');
    }

    function setGlobalWishlistState(isActive) {
      if (!wishlistButton) return;
      wishlistButton.classList.toggle('is-active', !!isActive);
      wishlistButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      wishlistButton.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    }

    function syncGlobalWishlistFromTile() {
      setGlobalWishlistState(wishlistButtonIsActive(activeTileWishlistButton()));
    }

    async function handleGlobalWishlistClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!wmCustomerIsLoggedIn()) {
        showWishlistLoginModal();
        return;
      }

      const product = wishlistProductFromCard(activeCard);
      const productKey = product?.handle || product?.productId || '';
      if (!productKey || wishlistClickPendingByProduct.has(productKey)) return;

      const tileButton = activeTileWishlistButton();
      const beforeState = wishlistOptimisticStateByProduct.has(productKey)
        ? wishlistOptimisticStateByProduct.get(productKey)
        : await currentWishlistStateForProduct(product, tileButton);
      const nextState = !beforeState;
      const canUseDirectWishlist = !!wishlistApi()?.addItem && !!wishlistApi()?.removeItem;

      wishlistClickPendingByProduct.add(productKey);
      wishlistOptimisticStateByProduct.set(productKey, nextState);
      updateWishlistCounter(nextState ? 1 : -1);
      syncTileWishlistButtons(product, nextState);
      setGlobalWishlistState(nextState);

      if (nextState) {
        const payload = wmGetForYouGridPayloadFromNode(activeCard);
        if (payload) {
          wmPostRecommendationEvent('/events', {
            event_type: 'wishlist_add',
            source: window.WM_FEED_SOURCE || 'collection',
            ...payload
          });
        }
      }

      let handledDirectly = false;
      try {
        handledDirectly = canUseDirectWishlist
          ? await mutateWishlistDirect(product, nextState).catch(() => false)
          : false;

        if (!handledDirectly) {
          const fallbackButton = tileButton || activeTileWishlistButton();
          if (fallbackButton) {
            fallbackButton.click();
          } else {
            scheduleWishlistRefresh();
            setTimeout(() => activeTileWishlistButton()?.click(), 500);
          }
        }

        await reconcileWishlistAfterClick(product, nextState);
      } finally {
        wishlistClickPendingByProduct.delete(productKey);
        wishlistOptimisticStateByProduct.delete(productKey);
        if (!handledDirectly) scheduleWishlistRefresh();
      }
    }

    function updatePlayerUi(resetProgress = true) {
      const releaseTitle = String(activeOverlay?.getAttribute('data-wm-grid-audio-title') || 'Preview').trim();
      const trackTitle = String(activeTitles[activeTrackIndex] || `Track ${activeTrackIndex + 1}`).trim();
      const cover = activeOverlay?.getAttribute('data-wm-grid-audio-cover') || '';
      const productUrl = activeOverlay?.getAttribute('data-wm-grid-audio-url') || '#';

      if (releaseEl) releaseEl.textContent = releaseTitle;
      if (trackEl) trackEl.textContent = trackTitle;
      if (productLinkEl) productLinkEl.href = productUrl;
      if (coverEl) {
        coverEl.src = cover;
        coverEl.alt = releaseTitle;
      }
      if (resetProgress) {
        setProgress(0);
        if (currentTimeEl) currentTimeEl.textContent = '0:00';
        if (durationEl) durationEl.textContent = '0:00';
      }
      player.classList.add('is-visible');
      document.body.classList.add('wm-grid-player-open');
      scheduleWishlistRefresh();
      setTimeout(syncGlobalWishlistFromTile, 300);
      setTimeout(syncGlobalWishlistFromTile, 1100);
    }

    function updateTileButtons(isPlaying) {
      shell.querySelectorAll('.wm-grid-audio-card.is-grid-audio-playing').forEach((card) => {
        if (card !== activeCard) card.classList.remove('is-grid-audio-playing');
      });
      if (activeCard) activeCard.classList.toggle('is-grid-audio-playing', !!isPlaying);
      if (activePlayButton) activePlayButton.setAttribute('aria-label', isPlaying ? 'Pause audio preview' : 'Play audio preview');
    }

    function setActive(overlay, src, trackIndex) {
      if (activeCard && activeCard !== overlay.closest('.wm-grid-audio-card')) {
        activeCard.classList.remove('is-grid-audio-playing');
      }
      if (activePlayButton && activePlayButton !== overlay.querySelector('[data-wm-grid-audio-play]')) {
        activePlayButton.setAttribute('aria-label', 'Play audio preview');
      }

      activeOverlay = overlay;
      activePlayButton = overlay.querySelector('[data-wm-grid-audio-play]');
      activeCard = overlay.closest('.wm-grid-audio-card');
      activeSrc = src;
      activeTrackIndex = trackIndex;
      activeTracks = parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').map(url => String(url || '').trim()).filter(Boolean);
      activeTitles = parseJsonAttribute(overlay, 'data-wm-grid-audio-titles');
      updatePlayerUi(true);
    }

    async function playOverlay(overlay, trackIndex = 0, toggle = true) {
      const urls = parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').map(url => String(url || '').trim()).filter(Boolean);
      if (!urls.length) return;
      const safeTrackIndex = Math.max(0, Math.min(urls.length - 1, Number(trackIndex) || 0));
      const src = urls[safeTrackIndex];
      const sameTrack = activeOverlay === overlay && activeSrc === src;

      if (toggle && sameTrack && !audio.paused) {
        audio.pause();
        updateTileButtons(false);
        return;
      }

      if (!sameTrack || audio.src !== src) {
        audio.pause();
        audio.removeAttribute('src');
        audio.src = src;
        audio.load();
      }

      setActive(overlay, src, safeTrackIndex);

      try {
        await audio.play();
      } catch (err) {
        updateTileButtons(false);
      }
    }

    async function playActiveTrack(trackIndex, toggle = false) {
      if (!activeOverlay || !activeTracks.length) return;
      const safeTrackIndex = Math.max(0, Math.min(activeTracks.length - 1, Number(trackIndex) || 0));
      const src = activeTracks[safeTrackIndex];
      const sameTrack = activeSrc === src;

      if (toggle && sameTrack && !audio.paused) {
        audio.pause();
        updateTileButtons(false);
        return;
      }

      activeTrackIndex = safeTrackIndex;
      activeSrc = src;
      updatePlayerUi(!sameTrack);

      if (!sameTrack || audio.src !== src) {
        audio.pause();
        audio.removeAttribute('src');
        audio.src = src;
        audio.load();
      }

      try {
        await audio.play();
      } catch (err) {
        updateTileButtons(false);
      }
    }

    function adjacentProductOverlay(direction = 1) {
      if (!activeCard) return null;
      const cards = Array.from(shell.querySelectorAll('.wm-grid-audio-card'));
      const currentIndex = cards.indexOf(activeCard);
      if (currentIndex === -1) return null;
      const step = direction >= 0 ? 1 : -1;
      for (let index = currentIndex + step; index >= 0 && index < cards.length; index += step) {
        const overlay = cards[index].querySelector('[data-wm-grid-audio]');
        const urls = overlay ? parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').filter(Boolean) : [];
        if (overlay && urls.length) return overlay;
      }
      return null;
    }

    function playAdjacentProduct(direction = 1) {
      const overlay = adjacentProductOverlay(direction);
      if (!overlay) return;
      const urls = parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').filter(Boolean);
      const trackIndex = direction >= 0 ? 0 : Math.max(0, urls.length - 1);
      playOverlay(overlay, trackIndex, false);
    }

    function changeTrack(direction) {
      if (!activeTracks.length) return;
      if (direction > 0 && activeTrackIndex >= activeTracks.length - 1) {
        playAdjacentProduct(1);
        return;
      }
      if (direction < 0 && activeTrackIndex <= 0) {
        playAdjacentProduct(-1);
        return;
      }
      playActiveTrack(activeTrackIndex + direction, false);
    }

    function dismissPlayer() {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      if (activeCard) activeCard.classList.remove('is-grid-audio-playing');
      activeOverlay = null;
      activeCard = null;
      activePlayButton = null;
      activeTracks = [];
      activeTitles = [];
      activeTrackIndex = 0;
      activeSrc = '';
      player.classList.remove('is-visible', 'is-playing');
      document.body.classList.remove('wm-grid-player-open');
    }

    function seekFromClientX(clientX) {
      if (!progressEl || !audio.duration) return;
      const rect = progressEl.getBoundingClientRect();
      if (!rect.width) return;
      const percent = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      audio.currentTime = percent * audio.duration;
      setProgress(percent * 100);
    }

    function seekFromEvent(event) {
      const clientX = event.clientX ?? (event.touches && event.touches[0] ? event.touches[0].clientX : null);
      if (clientX === null) return;
      seekFromClientX(clientX);
    }

    shell.addEventListener('click', (event) => {
      if (event.target.closest?.('.wm-grid-swish-anchor')) return;
      const overlay = event.target.closest('[data-wm-grid-audio]');
      if (!overlay || !shell.contains(overlay)) return;
      event.preventDefault();
      event.stopPropagation();
      playOverlay(overlay, activeOverlay === overlay ? activeTrackIndex : 0, true);
    }, true);

    shell.addEventListener('click', (event) => {
      const button = tileWishlistButtonFromEvent(event);
      if (!button || !shell.contains(button) || !event.isTrusted) return;
      handleTileWishlistClick(button, event);
    }, true);

    if (wishlistButton) {
      wishlistButton.addEventListener('click', handleGlobalWishlistClick);
    }

    playButton?.addEventListener('click', () => playActiveTrack(activeTrackIndex, true));
    prevButton?.addEventListener('click', () => changeTrack(-1));
    nextButton?.addEventListener('click', () => changeTrack(1));
    progressEl?.addEventListener('click', seekFromEvent);
    progressEl?.addEventListener('pointerdown', (event) => {
      if (!audio.duration) return;
      progressDragActive = true;
      progressEl.setPointerCapture?.(event.pointerId);
      seekFromClientX(event.clientX);
      event.preventDefault();
    });
    progressEl?.addEventListener('pointermove', (event) => {
      if (!progressDragActive) return;
      seekFromClientX(event.clientX);
      event.preventDefault();
    });
    progressEl?.addEventListener('pointerup', (event) => {
      if (!progressDragActive) return;
      progressDragActive = false;
      progressEl.releasePointerCapture?.(event.pointerId);
      event.preventDefault();
    });
    progressEl?.addEventListener('pointercancel', () => {
      progressDragActive = false;
    });

    player.addEventListener('touchstart', (event) => {
      if (event.target.closest('[data-wm-grid-player-progress]')) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      playerSwipeStartX = touch.clientX;
      playerSwipeStartY = touch.clientY;
      playerSwipeStartTime = Date.now();
    }, { passive: true });

    player.addEventListener('touchend', (event) => {
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      const deltaX = touch.clientX - playerSwipeStartX;
      const deltaY = touch.clientY - playerSwipeStartY;
      const elapsed = Date.now() - playerSwipeStartTime;
      if (elapsed > 900) return;
      if (deltaY > 54 && Math.abs(deltaY) > Math.abs(deltaX) * 1.25) {
        event.preventDefault();
        dismissPlayer();
      }
    }, { passive: false });

    function forYouGridAudioListenKey(payload) {
      return [
        payload?.product_handle || '',
        audio.currentSrc || audio.src || activeSrc || ''
      ].join('|');
    }

    function trackForYouGridAudioProgress() {
      const payload = wmGetForYouGridPayloadFromNode(activeCard || activeOverlay);
      const duration = Number(audio.duration || 0);
      const currentTime = Number(audio.currentTime || 0);
      if (!payload || duration <= 0 || currentTime <= 0) return;

      const key = forYouGridAudioListenKey(payload);
      const progress = audio.__wmForYouGridListenProgress || (audio.__wmForYouGridListenProgress = {});
      const state = progress[key] || {
        listenedSeconds: 0,
        lastCurrentTime: currentTime,
        lastUpdatedAt: Date.now()
      };
      const now = Date.now();
      const mediaDelta = currentTime - Number(state.lastCurrentTime || 0);
      const wallDelta = (now - Number(state.lastUpdatedAt || now)) / 1000;

      if (
        !audio.paused &&
        mediaDelta > 0 &&
        mediaDelta <= 2.5 &&
        wallDelta > 0 &&
        wallDelta <= 3
      ) {
        state.listenedSeconds += Math.min(mediaDelta, wallDelta + 0.5);
      }

      state.lastCurrentTime = currentTime;
      state.lastUpdatedAt = now;
      progress[key] = state;

      const percent = Math.floor((state.listenedSeconds / duration) * 100);
      const sent = audio.__wmForYouGridListenSent || (audio.__wmForYouGridListenSent = {});
      sent[key] = sent[key] || {};

      TRACKED_LISTEN_THRESHOLDS.forEach(threshold => {
        if (percent < threshold || sent[key][threshold]) return;
        sent[key][threshold] = true;
        wmPostRecommendationEvent('/events', {
          event_type: 'audio_listen_' + threshold,
          source: window.WM_FEED_SOURCE || 'collection',
          listen_percent: threshold,
          listen_seconds: Math.round(state.listenedSeconds),
          duration_seconds: Math.round(duration),
          ...payload
        });
      });
    }

    audio.addEventListener('pause', () => {
      player.classList.remove('is-playing');
      playButton?.setAttribute('aria-label', 'Play');
      updateTileButtons(false);
    });
    audio.addEventListener('play', () => {
      player.classList.add('is-playing', 'is-visible');
      playButton?.setAttribute('aria-label', 'Pause');
      document.body.classList.add('wm-grid-player-open');
      updateTileButtons(true);
    });
    audio.addEventListener('loadedmetadata', () => {
      audio.__wmForYouGridListenSent = {};
      audio.__wmForYouGridListenProgress = {};
      if (durationEl) durationEl.textContent = formatTime(audio.duration);
    });
    audio.addEventListener('timeupdate', () => {
      if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
      if (!audio.duration) return;
      setProgress((audio.currentTime / audio.duration) * 100);
      trackForYouGridAudioProgress();
    });
    audio.addEventListener('ended', () => {
      if (activeTracks.length && activeTrackIndex < activeTracks.length - 1) {
        playActiveTrack(activeTrackIndex + 1, false);
      } else {
        playAdjacentProduct(1);
      }
    });
    function stopAudioForPageExit() {
      audio.pause();
      updateTileButtons(false);
      player.classList.remove('is-playing');
    }
    window.addEventListener('pagehide', stopAudioForPageExit);
    window.addEventListener('beforeunload', stopAudioForPageExit);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') stopAudioForPageExit();
    });
    document.addEventListener('freeze', stopAudioForPageExit);

    scheduleWishlistRefresh();
    setTimeout(scheduleWishlistRefresh, 900);
  }

  async function wmRenderForYouGrid() {
    if (!FOR_YOU_GRID_VIEW) return;

    document.documentElement.classList.add('wm-for-you-grid-view');
    if (WM_IS_WEEKLY_DIGS_FEED) document.documentElement.classList.add('wm-weekly-digs-grid-view');
    wmInstallForYouGridStyles();
    wmSyncWeeklyDigsGridHeaderOffset();
    wmSyncForYouGridToggle();
    wmProtectForYouGridScrolling();
    wmStopForYouGridBackgroundMedia();
    window.setTimeout(wmSyncWeeklyDigsGridHeaderOffset, 100);
    window.setTimeout(wmSyncWeeklyDigsGridHeaderOffset, 500);
    window.addEventListener('resize', wmSyncWeeklyDigsGridHeaderOffset, { passive: true });
    window.setTimeout(wmSyncForYouGridToggle, 100);
    window.setTimeout(wmSyncForYouGridToggle, 500);
    window.setTimeout(wmStopForYouGridBackgroundMedia, 250);
    window.setTimeout(wmStopForYouGridBackgroundMedia, 1000);
    window.setTimeout(wmUnlockForYouGridPageScroll, 1500);
    window.setTimeout(wmUnlockForYouGridPageScroll, 2500);

    const shell = wmBuildForYouGridShell();
    const status = shell.querySelector('.wm-for-you-grid__status');
    const list = shell.querySelector('.wm-for-you-grid__items');
    const moreWrap = shell.querySelector('.wm-for-you-grid__more-wrap');
    const moreButton = shell.querySelector('.wm-for-you-grid__more');
    const moreSpinner = shell.querySelector('.wm-for-you-grid__more-spinner');
    if (!status || !list) return;

    try {
      const ranked = await window.WM_RECOMMENDATIONS_READY;
      const products = (Array.isArray(ranked) ? ranked : [])
        .filter(item => item && wmNormalizeHandle(item))
        .slice(0, 180);

      if (!products.length) {
        if (
          WM_IS_WEEKLY_DIGS_FEED &&
          (window.WM_RECOMMENDATIONS_STATUS === 'not_ready' || window.WM_RECOMMENDATIONS_STATUS === 'login_required')
        ) {
          wmShowWeeklyDigsNotReady();
        } else {
          status.textContent = 'No recommendations found.';
        }
        return;
      }

      const concurrency = 6;
      const batchSize = window.matchMedia?.('(max-width: 767px)')?.matches ? 16 : 24;
      let renderedCount = 0;
      let isRenderingBatch = false;
      const dwellState = new WeakMap();

      function installForYouGridDwellTracking() {
        if (!('IntersectionObserver' in window) || shell.dataset.wmForYouGridDwell === '1') return;
        shell.dataset.wmForYouGridDwell = '1';

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const tile = entry.target;
            const state = dwellState.get(tile) || {};

            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              state.visibleSince = state.visibleSince || Date.now();
              if (!state.timer && !state.sent) {
                state.timer = setTimeout(() => {
                  state.timer = null;
                  if (state.sent || !state.visibleSince) return;
                  const payload = wmGetForYouGridPayloadFromNode(tile);
                  if (!payload) return;
                  state.sent = true;
                  wmPostRecommendationEvent('/events', {
                    event_type: 'card_dwell_8s',
                    source: window.WM_FEED_SOURCE || 'collection',
                    ...payload
                  });
                }, 8000);
              }
            } else if (state.visibleSince) {
              if (state.timer) {
                clearTimeout(state.timer);
                state.timer = null;
              }
              state.visibleSince = null;
            }

            dwellState.set(tile, state);
          });
        }, { threshold: [0.55] });

        const observeTiles = (root = shell) => {
          root.querySelectorAll?.('[data-product-handle]').forEach((tile) => {
            if (tile.dataset.wmForYouGridDwellObserved === '1') return;
            tile.dataset.wmForYouGridDwellObserved = '1';
            observer.observe(tile);
          });
        };

        observeTiles();
        new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (!(node instanceof Element)) return;
              if (node.matches?.('[data-product-handle]')) {
                observeTiles(node.parentElement || shell);
              } else if (node.querySelector?.('[data-product-handle]')) {
                observeTiles(node);
              }
            });
          });
        }).observe(shell, { childList: true, subtree: true });
      }

      async function renderBatch() {
        if (isRenderingBatch || renderedCount >= products.length) return;
        isRenderingBatch = true;
        try {
          if (moreButton) {
            moreButton.disabled = true;
            moreButton.textContent = 'Load more';
          }
          if (moreSpinner && !moreWrap?.classList.contains('wm-for-you-grid__more-wrap--fallback')) {
            moreSpinner.hidden = renderedCount === 0;
          }

          const start = renderedCount;
          const end = Math.min(start + batchSize, products.length);
          const batch = products.slice(start, end);
          const tiles = new Array(batch.length);
          let cursor = 0;

          async function worker() {
            while (cursor < batch.length) {
              const batchIndex = cursor++;
              const productIndex = start + batchIndex;
              const handle = wmNormalizeHandle(batch[batchIndex]);
              try {
                tiles[batchIndex] = await wmFetchForYouGridTile(handle, productIndex, batch[batchIndex]);
              } catch (err) {
                console.warn('[WM Recommendations] Grid tile failed', handle, err);
              }
            }
          }

          await Promise.all(Array.from({ length: Math.min(concurrency, batch.length) }, worker));

          const fragment = document.createDocumentFragment();
          tiles.filter(Boolean).forEach(tile => fragment.appendChild(tile));
          list.appendChild(fragment);
          wmEnhanceForYouGridCartButtons(list);
          renderedCount = end;
          list.hidden = false;
          status.hidden = true;

          if (moreWrap && moreButton) {
            const hasMore = renderedCount < products.length;
            moreWrap.hidden = !hasMore;
            moreButton.disabled = false;
            moreButton.textContent = 'Load more';
          }
          if (moreSpinner) moreSpinner.hidden = true;

          wmStopForYouGridBackgroundMedia();
          wmUnlockForYouGridPageScroll();
          wmInstallForYouGridPlayer(shell);
          wmScheduleForYouGridCartButtonAlignment(list);
          if (typeof window.WishlistKing?.reload === 'function') {
            try { window.WishlistKing.reload(); } catch (e) {}
          }
        } finally {
          isRenderingBatch = false;
        }
      }

      function handleBatchError(err) {
        console.warn('[WM Recommendations] Grid batch failed', err);
        if (moreWrap) {
          moreWrap.hidden = false;
          moreWrap.classList.add('wm-for-you-grid__more-wrap--fallback');
        }
        if (moreSpinner) moreSpinner.hidden = true;
        if (moreButton) {
          moreButton.disabled = false;
          moreButton.textContent = 'Load more';
        }
      }

      function loadNextBatch() {
        renderBatch().catch(handleBatchError);
      }

      function setupInfiniteLoad() {
        if (!moreWrap || moreWrap.dataset.wmForYouInfiniteBound) return;
        moreWrap.dataset.wmForYouInfiniteBound = '1';
        if (typeof IntersectionObserver === 'undefined') {
          moreWrap.classList.add('wm-for-you-grid__more-wrap--fallback');
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (moreWrap.hidden || renderedCount >= products.length || isRenderingBatch) return;
            loadNextBatch();
          });
        }, {
          root: null,
          rootMargin: '700px 0px 700px 0px',
          threshold: 0,
        });

        observer.observe(moreWrap);
      }

      if (moreButton && !moreButton.dataset.wmForYouMoreBound) {
        moreButton.dataset.wmForYouMoreBound = '1';
        moreButton.addEventListener('click', loadNextBatch);
      }

      if (shell.dataset.wmForYouGridCartHandler !== '1') {
        shell.dataset.wmForYouGridCartHandler = '1';
        shell.addEventListener('click', (event) => {
          const link = event.target.closest('a[href*="/products/"]');
          if (!link || !shell.contains(link)) return;
          if (event.target.closest('.wm-grid-swish-anchor, [data-wm-grid-audio], .wm-wishlist-cart-button')) return;
          const payload = wmGetForYouGridPayloadFromNode(link);
          if (!payload) return;
          wmPostRecommendationEvent('/events', {
            event_type: 'product_click',
            source: window.WM_FEED_SOURCE || 'collection',
            ...payload
          });
        }, true);
        shell.addEventListener('click', (event) => {
          const button = event.target.closest('.wm-wishlist-cart-button');
          if (!button || !shell.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          wmHandleForYouGridCartClick(button);
        });
        window.addEventListener('resize', () => wmScheduleForYouGridCartButtonAlignment(list));
        shell.addEventListener('load', (event) => {
          if (event.target && event.target.tagName === 'IMG') wmScheduleForYouGridCartButtonAlignment(list);
        }, true);
      }

      installForYouGridDwellTracking();
      setupInfiniteLoad();
      await renderBatch();
    } catch (err) {
      console.warn('[WM Recommendations] Grid render failed', err);
      status.textContent = 'Recommendations are unavailable right now.';
    }
  }

  async function wmRefreshUnseenRecommendations() {
    if (!WM_IS_RECOMMENDATIONS_FEED) return false;
    if (window.WM_RECOMMENDATIONS_REFRESHING) return false;

    const source = Array.isArray(window.WM_ACTIVE_COLLECTION_INDEX) ? window.WM_ACTIVE_COLLECTION_INDEX : [];
    const byHandle = new Map(source.map(item => [wmNormalizeHandle(item), item]).filter(pair => pair[0]));
    const renderedHandles = wmRenderedProductHandles();
    const renderedSet = new Set(renderedHandles);
    const seen = renderedHandles.map(handle => byHandle.get(handle)).filter(Boolean);
    const unseen = source.filter(item => {
      const handle = wmNormalizeHandle(item);
      return handle && !renderedSet.has(handle);
    });
    if (!unseen.length) {
      window.WM_RECOMMENDATIONS_STALE = false;
      return false;
    }

    window.WM_RECOMMENDATIONS_REFRESHING = true;

    try {
      const ranked = await wmFetchRecommendedHandles(unseen);
      const byUnseenHandle = new Map(unseen.map(item => [wmNormalizeHandle(item), item]).filter(pair => pair[0]));
      const used = new Set();
      const refreshed = [];

      ranked.forEach((recommendation, index) => {
        const item = byUnseenHandle.get(recommendation.handle);
        if (!item || used.has(recommendation.handle)) return;

        used.add(recommendation.handle);
        refreshed.push({
          ...item,
          wm_recommendation: {
            rank: seen.length + index + 1,
            score: recommendation.score,
            raw_score: recommendation.raw_score,
            contrast_factor: recommendation.contrast_factor,
            fatigue_factor: recommendation.fatigue_factor,
            archive_age_days: recommendation.archive_age_days,
            archive_boost: recommendation.archive_boost,
            branch_score: recommendation.branch_score,
            weekly_digs_tier: recommendation.weekly_digs_tier || '',
            weekly_digs_history_repeat: recommendation.weekly_digs_history_repeat === true,
            weekly_digs_fallback: recommendation.weekly_digs_fallback === true,
            blend_source: recommendation.blend_source || '',
            reason_codes: recommendation.reason_codes || []
          }
        });
      });

      unseen.forEach(item => {
        const handle = wmNormalizeHandle(item);
        if (!handle || used.has(handle)) return;
        refreshed.push(item);
      });

      window.WM_ACTIVE_COLLECTION_INDEX = seen.concat(refreshed);
      window.WM_RECOMMENDATIONS_STALE = false;

      if (DEBUG_ENABLED) {
        setTimeout(() => wmApplyRecommendationDebugOverlay(document), 0);
      }

      return true;
    } catch (err) {
      console.warn('[WM Recommendations] Mid-session refresh failed', err);
      return false;
    } finally {
      window.WM_RECOMMENDATIONS_REFRESHING = false;
    }
  }

  window.WM_refreshUnseenRecommendations = wmRefreshUnseenRecommendations;

  function wmScheduleRecommendationRefresh(delayMs = 700) {
    if (!WM_IS_RECOMMENDATIONS_FEED) return;
    window.WM_RECOMMENDATIONS_STALE = true;
    if (wmRecommendationRefreshTimer) clearTimeout(wmRecommendationRefreshTimer);

    wmRecommendationRefreshTimer = setTimeout(() => {
      wmRecommendationRefreshTimer = null;
      if (typeof window.WM_refreshUnseenRecommendations === 'function') {
        window.WM_refreshUnseenRecommendations();
      }
    }, delayMs);
  }

  function wmInstallDebugStyles() {
    if (!DEBUG_ENABLED || document.getElementById('wmRecommendationDebugStyles')) return;

    const style = document.createElement('style');
    style.id = 'wmRecommendationDebugStyles';
    style.textContent = `
      #verticalSwipeContainer .wm-rec-debug-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 50;
        max-width: min(82%, 340px);
        padding: 8px 10px;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.78);
        color: #fff;
        font: 11px/1.35 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing: 0;
        pointer-events: none;
        box-shadow: 0 2px 10px rgba(0,0,0,.25);
      }
      #verticalSwipeContainer .wm-rec-debug-badge strong {
        display: block;
        margin-bottom: 2px;
        font-size: 11px;
      }
      #verticalSwipeContainer .wm-rec-debug-badge span {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .wm-rec-debug-controls {
        position: fixed;
        right: 12px;
        bottom: 12px;
        z-index: 9999;
        width: min(520px, calc(100vw - 24px));
        display: grid;
        gap: 8px;
        padding: 8px;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.78);
        color: #fff;
        font: 12px/1.3 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }
      .wm-rec-debug-controls__actions {
        display: flex;
        gap: 8px;
        align-items: center;
      }
      .wm-rec-debug-controls button {
        appearance: none;
        border: 1px solid rgba(255,255,255,.55);
        border-radius: 4px;
        background: rgba(255,255,255,.12);
        color: #fff;
        padding: 7px 9px;
        font: inherit;
        cursor: pointer;
      }
      .wm-rec-debug-controls button:disabled {
        opacity: .6;
        cursor: wait;
      }
      .wm-rec-debug-profile {
        max-height: min(58vh, 520px);
        overflow: auto;
        padding-top: 6px;
        border-top: 1px solid rgba(255,255,255,.25);
      }
      .wm-rec-debug-profile strong,
      .wm-rec-debug-profile span {
        display: block;
      }
      .wm-rec-debug-profile__row {
        display: grid;
        grid-template-columns: 82px 1fr 72px;
        gap: 6px;
        align-items: baseline;
        margin-top: 3px;
      }
      .wm-rec-debug-profile__type {
        opacity: .72;
      }
      .wm-rec-debug-profile__value {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `;
    document.head.appendChild(style);
  }

  function wmEntityTypeLabel(type) {
    return {
      genre: 'Genre',
      sub_genre: 'Subgenre',
      mood_style: 'Descriptor',
      label: 'Label',
      artist: 'Artist',
      other_tag: 'Other'
    }[type] || type;
  }

  function wmRenderDebugProfile(container, profile) {
    const profileBox = container.querySelector('.wm-rec-debug-profile');
    if (!profileBox) return;

    const rows = Array.isArray(profile?.top_scores) ? profile.top_scores : [];
    profileBox.innerHTML = `
      <strong>Profile score: ${Number(profile?.total_score || 0).toFixed(2)}</strong>
      ${profile?.last_event_type ? `<span>Last: ${String(profile.last_event_type).replace(/[<>&"]/g, '')}</span>` : ''}
      ${rows.length ? `<span>Showing ${rows.length} scored tags</span>` : ''}
      ${rows.map(row => `
        <span class="wm-rec-debug-profile__row">
          <span class="wm-rec-debug-profile__type">${wmEntityTypeLabel(row.entity_type)}</span>
          <span class="wm-rec-debug-profile__value">${String(row.entity_value || '').replace(/[<>&"]/g, '')}</span>
          <span>${Number(row.score || 0).toFixed(2)}</span>
        </span>
      `).join('')}
      ${!rows.length ? '<span>No scores yet.</span>' : ''}
    `;
  }

  async function wmRefreshDebugProfile(container) {
    if (!DEBUG_ENABLED || !container) return;
    const profileBox = container.querySelector('.wm-rec-debug-profile');
    if (profileBox) profileBox.innerHTML = '<strong>Profile score</strong><span>Loading...</span>';

    try {
      const response = await fetch(PROXY_BASE + '/debug/profile', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          ...wmDebugHeaders()
        },
        body: JSON.stringify(wmRecommendationIdentity())
      });

      if (!response.ok) throw new Error('Profile failed: ' + response.status);
      const profile = await response.json();
      window.WM_RECOMMENDATIONS_PROFILE_DEBUG = profile;
      wmRenderDebugProfile(container, profile);
    } catch (err) {
      if (profileBox) profileBox.innerHTML = '<strong>Profile score</strong><span>Unavailable</span>';
      console.warn('[WM Recommendations] Profile debug failed', err);
    }
  }

  function wmInstallDebugControls() {
    if (!DEBUG_ENABLED || document.getElementById('wmRecommendationDebugControls')) return;
    wmInstallDebugStyles();

    const controls = document.createElement('div');
    controls.id = 'wmRecommendationDebugControls';
    controls.className = 'wm-rec-debug-controls';

    const actions = document.createElement('div');
    actions.className = 'wm-rec-debug-controls__actions';

    const resetButton = document.createElement('button');
    resetButton.type = 'button';
    resetButton.textContent = 'Reset test profile';
    resetButton.addEventListener('click', async () => {
      if (!window.confirm('Reset recommendation scores and fatigue for this test profile?')) return;

      resetButton.disabled = true;
      resetButton.textContent = 'Resetting...';

      try {
        const response = await fetch(PROXY_BASE + '/debug/reset-profile', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...wmDebugHeaders()
          },
          body: JSON.stringify(wmRecommendationIdentity())
        });

        if (!response.ok) throw new Error('Reset failed: ' + response.status);
        sessionStorage.removeItem(SESSION_ID_KEY);
        window.location.reload();
      } catch (err) {
        console.warn('[WM Recommendations] Reset failed', err);
        resetButton.disabled = false;
        resetButton.textContent = 'Reset failed';
        setTimeout(() => {
          resetButton.textContent = 'Reset test profile';
        }, 2500);
      }
    });

    const refreshButton = document.createElement('button');
    refreshButton.type = 'button';
    refreshButton.textContent = 'Refresh profile';
    refreshButton.addEventListener('click', () => wmRefreshDebugProfile(controls));

    const resetWeeklyButton = document.createElement('button');
    resetWeeklyButton.type = 'button';
    resetWeeklyButton.textContent = 'Reset Weekly Digs';
    resetWeeklyButton.hidden = !WM_IS_WEEKLY_DIGS_FEED;
    resetWeeklyButton.addEventListener('click', async () => {
      if (!window.confirm("Reset this test account's current Weekly Digs snapshot? Your taste score will not be changed.")) return;

      resetWeeklyButton.disabled = true;
      resetWeeklyButton.textContent = 'Resetting...';

      try {
        const response = await fetch(PROXY_BASE + '/debug/reset-weekly-digs', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...wmDebugHeaders()
          },
          body: JSON.stringify(wmRecommendationIdentity())
        });

        if (!response.ok) throw new Error('Weekly Digs reset failed: ' + response.status);
        window.location.reload();
      } catch (err) {
        console.warn('[WM Recommendations] Weekly Digs reset failed', err);
        resetWeeklyButton.disabled = false;
        resetWeeklyButton.textContent = 'Reset failed';
        setTimeout(() => {
          resetWeeklyButton.textContent = 'Reset Weekly Digs';
        }, 2500);
      }
    });

    const resetWeeklyTestDataButton = document.createElement('button');
    resetWeeklyTestDataButton.type = 'button';
    resetWeeklyTestDataButton.textContent = 'Clean Weekly Digs test';
    resetWeeklyTestDataButton.hidden = !WM_IS_WEEKLY_DIGS_FEED;
    resetWeeklyTestDataButton.addEventListener('click', async () => {
      if (!window.confirm('Clear this test profile, current Weekly Digs snapshot, and Weekly Digs debug history?')) return;

      resetWeeklyTestDataButton.disabled = true;
      resetWeeklyTestDataButton.textContent = 'Cleaning...';

      try {
        const response = await fetch(PROXY_BASE + '/debug/reset-weekly-digs-test-data', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...wmDebugHeaders()
          },
          body: JSON.stringify(wmRecommendationIdentity())
        });

        if (!response.ok) throw new Error('Weekly Digs test reset failed: ' + response.status);
        sessionStorage.removeItem(SESSION_ID_KEY);
        window.location.reload();
      } catch (err) {
        console.warn('[WM Recommendations] Weekly Digs test reset failed', err);
        resetWeeklyTestDataButton.disabled = false;
        resetWeeklyTestDataButton.textContent = 'Clean failed';
        setTimeout(() => {
          resetWeeklyTestDataButton.textContent = 'Clean Weekly Digs test';
        }, 2500);
      }
    });

    const profile = document.createElement('div');
    profile.className = 'wm-rec-debug-profile';
    profile.innerHTML = '<strong>Profile score</strong><span>Loading...</span>';

    actions.appendChild(resetButton);
    actions.appendChild(resetWeeklyButton);
    actions.appendChild(resetWeeklyTestDataButton);
    actions.appendChild(refreshButton);
    controls.appendChild(actions);
    controls.appendChild(profile);
    document.body.appendChild(controls);
    wmRefreshDebugProfile(controls);
  }

  function wmApplyRecommendationDebugOverlay(root = document) {
    if (!DEBUG_ENABLED) return;
    wmInstallDebugStyles();

    const source = Array.isArray(window.WM_ACTIVE_COLLECTION_INDEX) ? window.WM_ACTIVE_COLLECTION_INDEX : [];
    const byHandle = new Map(source.map(item => [wmNormalizeHandle(item), item]).filter(pair => pair[0]));

    const slides = [];
    if (
      root instanceof Element &&
      root.matches('#verticalSwipeContainer .product-slide[data-product-handle], .product-slide[data-product-handle]')
    ) {
      slides.push(root);
    }

    root.querySelectorAll?.('#verticalSwipeContainer .product-slide[data-product-handle], .product-slide[data-product-handle]')
      .forEach(slide => slides.push(slide));

    Array.from(new Set(slides)).forEach(slide => {
      if (slide.querySelector('.wm-rec-debug-badge')) return;

      const handle = slide.getAttribute('data-product-handle') || '';
      const item = byHandle.get(handle);
      const recommendation = item?.wm_recommendation;
      if (!recommendation) return;

      const inner = slide.querySelector('.product-slide-inner') || slide;
      if (getComputedStyle(inner).position === 'static') {
        inner.style.position = 'relative';
      }

      const allReasons = Array.isArray(recommendation.reason_codes)
        ? recommendation.reason_codes
        : [];
      const descriptorReasons = allReasons.filter(reason => String(reason).startsWith('mood_style:'));
      const diagnosticReasons = allReasons.filter(reason => /^(contrast|unmatched|weak_match|fatigue):/.test(String(reason)));
      const otherReasons = allReasons.filter(reason => {
        const value = String(reason);
        return !value.startsWith('mood_style:') && !/^(contrast|unmatched|weak_match|fatigue):/.test(value);
      });
      const reasons = diagnosticReasons.concat(descriptorReasons, otherReasons).slice(0, 10);
      const sourceLabel = {
        personalized: 'Personalized match',
        branch: 'Branch match',
        exploration: 'Exploration pick',
        new_arrival: 'New arrival',
        archive: 'Archive match',
        weekly_digs_core: 'Weekly Digs: Core',
        weekly_digs_broad_core: 'Weekly Digs: Broad-core',
        weekly_digs_adjacent: 'Weekly Digs: Adjacent',
        weekly_digs_archive: 'Weekly Digs: Archive',
        weekly_digs_fallback: 'Weekly Digs: Similar',
        fallback: 'Fallback'
      }[recommendation.blend_source] || 'Recommended';

      const badge = document.createElement('div');
      badge.className = 'wm-rec-debug-badge';
      badge.innerHTML = `
        <strong>${sourceLabel} #${recommendation.rank || '-'}</strong>
        <span>Match score: ${Number(recommendation.score || 0).toFixed(2)}</span>
        ${recommendation.weekly_digs_tier ? `<span>Weekly Digs tier: ${String(recommendation.weekly_digs_tier).replace(/[<>&"]/g, '')}</span>` : ''}
        ${recommendation.weekly_digs_history_repeat ? '<span>Weekly Digs repeat refill</span>' : ''}
        ${recommendation.blend_source === 'branch' ? `<span>Branch score: ${Number(recommendation.branch_score || 0).toFixed(2)}</span>` : ''}
        ${recommendation.blend_source === 'archive' && recommendation.archive_age_days ? `<span>Archive age: ${Number(recommendation.archive_age_days)} days</span>` : ''}
        ${recommendation.blend_source === 'archive' && recommendation.archive_boost ? `<span>Archive boost: ${Math.round(Number(recommendation.archive_boost) * 100)}%</span>` : ''}
        ${recommendation.contrast_factor < 1 ? `<span>Contrast factor: ${Number(recommendation.contrast_factor).toFixed(2)}</span>` : ''}
        ${recommendation.fatigue_factor < 1 ? `<span>Fatigue factor: ${Number(recommendation.fatigue_factor).toFixed(2)}</span>` : ''}
        ${reasons.map(reason => `<span>${String(reason).replace(/[<>&"]/g, '')}</span>`).join('')}
      `;
      inner.appendChild(badge);
    });
  }

  function wmPostRecommendationEvent(path, payload) {
    if (!wmRecommendationsEnabled()) return Promise.resolve(null);

    if (path === '/events') {
      wmApplySessionAffinity(payload?.event_type, payload?.metadata);
      wmTrackSessionCluster(payload?.event_type, payload?.metadata, payload?.product_handle);
      wmApplyBranchAffinity(payload?.event_type, payload?.metadata, payload?.recommendation);
    }

    return fetch(PROXY_BASE + path, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        ...wmRecommendationIdentity(),
        occurred_at: new Date().toISOString(),
        ...payload
      }),
      keepalive: true
    }).then(response => {
      if (
        path === '/events' &&
        response.ok &&
        RERANK_EVENT_TYPES.has(payload?.event_type)
      ) {
        wmScheduleRecommendationRefresh(payload?.event_type === 'product_click' ? 1200 : 500);
      }

      if (DEBUG_ENABLED && path === '/events' && response.ok) {
        const controls = document.getElementById('wmRecommendationDebugControls');
        if (controls) setTimeout(() => wmRefreshDebugProfile(controls), 250);
      }

      return response;
    }).catch(() => {});
  }

  function wmGetSlidePayload(slide) {
    if (!slide) return null;
    const handle = slide.getAttribute('data-product-handle') || '';
    if (!handle) return null;

    const source = Array.isArray(window.WM_ACTIVE_COLLECTION_INDEX) ? window.WM_ACTIVE_COLLECTION_INDEX : [];
    const item = source.find(candidate => wmNormalizeHandle(candidate) === handle) || {};
    const parsedTags = wmParseRecommendationTags(item.tags);

    return {
      product_handle: handle,
      product_id: slide.getAttribute('data-product-id') || item.id || item.product_id || null,
      recommendation: item.wm_recommendation || null,
      metadata: {
        artists: wmCleanRecommendationValues(Array.isArray(item.artists) ? item.artists : (item.artist ? [item.artist] : parsedTags.artists)),
        labels: wmCleanRecommendationValues(Array.isArray(item.labels) ? item.labels : (item.label ? [item.label] : parsedTags.labels)),
        genres: wmCleanRecommendationValues(item.genres || parsedTags.genres),
        sub_genres: wmCleanRecommendationValues(item.sub_genres || item.subGenres || parsedTags.sub_genres),
        mood_style: wmCleanRecommendationValues(item.mood_style || item.moodStyle || parsedTags.mood_style),
        other_tags: wmCleanRecommendationValues(item.other_tags || item.otherTags || parsedTags.other_tags),
        raw_tags: wmCleanRecommendationValues(Array.isArray(item.tags) ? item.tags : [])
      }
    };
  }

  function wmGetForYouGridPayloadFromNode(node) {
    if (!node) return null;
    const tile = node.closest?.('[data-product-handle]');
    const handle = tile?.getAttribute('data-product-handle') || '';
    if (!handle) return null;

    const source = Array.isArray(window.WM_ACTIVE_COLLECTION_INDEX) ? window.WM_ACTIVE_COLLECTION_INDEX : [];
    const item = source.find(candidate => wmNormalizeHandle(candidate) === handle) || {};
    const overlay = tile.querySelector?.('[data-wm-grid-audio]');
    const parsedTags = wmParseRecommendationTags(item.tags);

    return {
      product_handle: handle,
      product_id: overlay?.getAttribute('data-wm-grid-audio-product-id') ||
        tile.getAttribute('data-product-id') ||
        item.id ||
        item.product_id ||
        null,
      recommendation: item.wm_recommendation || null,
      metadata: {
        artists: wmCleanRecommendationValues(Array.isArray(item.artists) ? item.artists : (item.artist ? [item.artist] : parsedTags.artists)),
        labels: wmCleanRecommendationValues(Array.isArray(item.labels) ? item.labels : (item.label ? [item.label] : parsedTags.labels)),
        genres: wmCleanRecommendationValues(item.genres || parsedTags.genres),
        sub_genres: wmCleanRecommendationValues(item.sub_genres || item.subGenres || parsedTags.sub_genres),
        mood_style: wmCleanRecommendationValues(item.mood_style || item.moodStyle || parsedTags.mood_style),
        other_tags: wmCleanRecommendationValues(item.other_tags || item.otherTags || parsedTags.other_tags),
        raw_tags: wmCleanRecommendationValues(Array.isArray(item.tags) ? item.tags : [])
      }
    };
  }

  function wmGetProductPagePayload() {
    const item = window.WM_PRODUCT_RECOMMENDATION_DATA;
    if (!item || typeof item !== 'object') return null;

    const handle = wmNormalizeHandle(item);
    if (!handle) return null;

    const parsedTags = wmParseRecommendationTags(item.tags);

    return {
      product_handle: handle,
      product_id: item.id || item.product_id || null,
      recommendation: null,
      metadata: {
        artists: wmCleanRecommendationValues(Array.isArray(item.artists) ? item.artists : (item.artist ? [item.artist] : parsedTags.artists)),
        labels: wmCleanRecommendationValues(Array.isArray(item.labels) ? item.labels : (item.label ? [item.label] : parsedTags.labels)),
        genres: wmCleanRecommendationValues(item.genres || parsedTags.genres),
        sub_genres: wmCleanRecommendationValues(item.sub_genres || item.subGenres || parsedTags.sub_genres),
        mood_style: wmCleanRecommendationValues(item.mood_style || item.moodStyle || parsedTags.mood_style),
        other_tags: wmCleanRecommendationValues(item.other_tags || item.otherTags || parsedTags.other_tags),
        raw_tags: wmCleanRecommendationValues(Array.isArray(item.tags) ? item.tags : [])
      }
    };
  }

  function wmInstallProductPageTracking() {
    if (window.WM_FEED_SOURCE !== 'product') return;

    const payload = wmGetProductPagePayload();
    if (!payload) return;
    const trackedCartForms = new WeakSet();

    function productPageWishlistButtonFromEvent(event) {
      return event.target.closest([
        '.wk-button',
        '.gropulse-wishlist-button',
        '[data-wishlist]',
        '[data-wishlist-button]',
        '[data-wk-add-product]',
        '[aria-label*="wishlist" i]',
        '[title*="wishlist" i]'
      ].join(','));
    }

    function productPageWishlistLooksLikeRemove(button) {
      if (!button) return false;
      const state = [
        button.getAttribute('aria-label'),
        button.getAttribute('title'),
        button.getAttribute('data-state'),
        button.textContent,
        button.className
      ].join(' ').toLowerCase();
      return state.includes('remove') || state.includes('in wishlist');
    }

    function postProductPageAddToCart() {
      wmPostRecommendationEvent('/events', {
        event_type: 'add_to_cart',
        source: 'product',
        ...payload
      });
    }

    try {
      const viewKey = `wm_rec_product_view:${payload.product_handle}`;
      if (sessionStorage.getItem(viewKey) !== '1') {
        sessionStorage.setItem(viewKey, '1');
        wmPostRecommendationEvent('/events', {
          event_type: 'product_view',
          source: 'product',
          ...payload
        });
      }
    } catch (e) {
      wmPostRecommendationEvent('/events', {
        event_type: 'product_view',
        source: 'product',
        ...payload
      });
    }

    document.addEventListener('click', event => {
      const wishlistButton = productPageWishlistButtonFromEvent(event);
      const cartButton = event.target.closest('.add-to-cart, [name="add"], .product-form__submit, form[action*="/cart/add"] button[type="submit"]');
      const target = wishlistButton || cartButton;
      if (!target) return;

      if (wishlistButton) {
        if (productPageWishlistLooksLikeRemove(wishlistButton)) return;
        wmPostRecommendationEvent('/events', {
          event_type: 'wishlist_add',
          source: 'product',
          ...payload
        });
        return;
      }

      const form = cartButton.closest?.('form[action*="/cart/add"]');
      if (form) {
        trackedCartForms.add(form);
        setTimeout(() => trackedCartForms.delete(form), 1000);
      }
      postProductPageAddToCart();
    }, true);

    document.addEventListener('submit', event => {
      const form = event.target?.closest?.('form[action*="/cart/add"]');
      if (!form || trackedCartForms.has(form)) return;
      trackedCartForms.add(form);
      setTimeout(() => trackedCartForms.delete(form), 1000);
      postProductPageAddToCart();
    }, true);
  }

  function wmInstallImpressionTracking() {
    const container = document.getElementById('verticalSwipeContainer');
    if (!container || typeof IntersectionObserver === 'undefined') return;
    const visibilityState = new WeakMap();

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const slide = entry.target;
        const state = visibilityState.get(slide) || {};

        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
          state.visibleSince = state.visibleSince || Date.now();

          if (WM_IS_PERSONALIZED_FEED && slide.getAttribute(IMPRESSION_SENT_ATTR) !== '1') {
            slide.setAttribute(IMPRESSION_SENT_ATTR, '1');

            const payload = wmGetSlidePayload(slide);
            if (payload) {
              wmPostRecommendationEvent('/impressions', {
                event_type: 'product_impression',
                source: window.WM_FEED_SOURCE || 'collection',
                position: Array.from(container.querySelectorAll('.product-slide[data-product-handle]')).indexOf(slide) + 1,
                ...payload
              });
            }
          }

          if (!state.dwellTimer && !state.dwellSent) {
            state.dwellTimer = setTimeout(() => {
              state.dwellTimer = null;
              if (!state.visibleSince || state.dwellSent) return;

              const payload = wmGetSlidePayload(slide);
              if (!payload) return;

              state.dwellSent = true;
              wmPostRecommendationEvent('/events', {
                event_type: 'card_dwell_8s',
                source: window.WM_FEED_SOURCE || 'collection',
                ...payload
              });
            }, 8000);
          }
        } else if (state.visibleSince) {
          const visibleMs = Date.now() - state.visibleSince;
          if (state.dwellTimer) {
            clearTimeout(state.dwellTimer);
            state.dwellTimer = null;
          }

          if (visibleMs > 250 && visibleMs < 1800 && !state.quickSkipSent && !state.dwellSent) {
            const payload = wmGetSlidePayload(slide);
            if (payload) {
              state.quickSkipSent = true;
              if (WM_IS_PERSONALIZED_FEED) {
                wmApplySessionAffinity('quick_skip_card', payload.metadata);
                window.WM_RECOMMENDATIONS_STALE = true;
                wmScheduleRecommendationRefresh(900);
              }
            }
          }

          state.visibleSince = null;
        }

        visibilityState.set(slide, state);
      });
    }, { root: container, threshold: [0.55] });

    const observeSlides = root => {
      root.querySelectorAll('.product-slide[data-product-handle]').forEach(slide => observer.observe(slide));
    };

    observeSlides(container);

    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches && node.matches('.product-slide[data-product-handle]')) observer.observe(node);
          observeSlides(node);
        });
      });
    }).observe(container, { childList: true, subtree: true });
  }

  function wmInstallInteractionTracking() {
    document.addEventListener('click', event => {
      const wishlistButton = event.target.closest('#verticalSwipeContainer .wk-button');
      const cartButton = event.target.closest('#verticalSwipeContainer .add-to-cart');
      const productLink = event.target.closest('#verticalSwipeContainer .view-product-button, #verticalSwipeContainer a[href*="/products/"]');
      const target = wishlistButton || cartButton || productLink;
      if (!target) return;

      const slide = target.closest('.product-slide[data-product-handle]');
      const payload = wmGetSlidePayload(slide);
      if (!payload) return;

      let eventType = 'product_click';
      if (wishlistButton) eventType = 'wishlist_add';
      if (cartButton) eventType = 'add_to_cart';

      wmPostRecommendationEvent('/events', {
        event_type: eventType,
        source: window.WM_FEED_SOURCE || 'collection',
        ...payload
      });
    }, true);

    function wmAudioListenKey(payload, audio) {
      return [
        payload.product_handle,
        audio.currentSrc || audio.src || window.WM_AUDIO_STATE?.src || ''
      ].join('|');
    }

    function handleAudioProgress(audio) {
      const slide =
        window.WM_AUDIO_STATE?.productSlide ||
        window.WM_AUDIO_STATE?.slide?.closest?.('.product-slide[data-product-handle]') ||
        null;
      const payload = wmGetSlidePayload(slide) || wmGetProductPagePayload();
      const duration = Number(audio.duration || 0);
      const currentTime = Number(audio.currentTime || 0);
      if (!payload || duration <= 0 || currentTime <= 0) return;

      const key = wmAudioListenKey(payload, audio);
      const progress = audio.__wmRecommendationListenProgress || (audio.__wmRecommendationListenProgress = {});
      const state = progress[key] || {
        listenedSeconds: 0,
        lastCurrentTime: currentTime,
        lastUpdatedAt: Date.now()
      };
      const now = Date.now();
      const mediaDelta = currentTime - Number(state.lastCurrentTime || 0);
      const wallDelta = (now - Number(state.lastUpdatedAt || now)) / 1000;

      if (
        !audio.paused &&
        mediaDelta > 0 &&
        mediaDelta <= 2.5 &&
        wallDelta > 0 &&
        wallDelta <= 3
      ) {
        const listenedDelta = Math.min(mediaDelta, wallDelta + 0.5);
        state.listenedSeconds += listenedDelta;
      }

      state.lastCurrentTime = currentTime;
      state.lastUpdatedAt = now;
      progress[key] = state;

      const percent = Math.floor((state.listenedSeconds / duration) * 100);
      const sent = audio.__wmRecommendationListenSent || (audio.__wmRecommendationListenSent = {});
      sent[key] = sent[key] || {};

      TRACKED_LISTEN_THRESHOLDS.forEach(threshold => {
        if (percent < threshold || sent[key][threshold]) return;
        sent[key][threshold] = true;

        wmPostRecommendationEvent('/events', {
          event_type: 'audio_listen_' + threshold,
          source: window.WM_FEED_SOURCE || 'collection',
          listen_percent: threshold,
          listen_seconds: Math.round(state.listenedSeconds),
          duration_seconds: Math.round(duration),
          ...payload
        });
      });
    }

    function bindAudioProgress() {
      const audios = [];
      const player = document.getElementById('WM_PLAYER');
      if (player) audios.push(player);
      if (window.WM_FEED_SOURCE === 'product') {
        document.querySelectorAll('audio').forEach(audio => audios.push(audio));
      }
      const uniqueAudios = Array.from(new Set(audios)).filter(Boolean);
      let boundAny = false;

      uniqueAudios.forEach(audio => {
        if (audio.__wmRecommendationProgressBound) {
          boundAny = true;
          return;
        }

        audio.__wmRecommendationProgressBound = true;
        boundAny = true;
        audio.addEventListener('timeupdate', () => handleAudioProgress(audio));
        audio.addEventListener('seeking', () => {
          audio.__wmRecommendationSeekStartedAt = Number(audio.currentTime || 0);
        });
        audio.addEventListener('seeked', () => {
          const progress = audio.__wmRecommendationListenProgress || {};
          const to = Number(audio.currentTime || 0);
          Object.values(progress).forEach(state => {
            if (!state) return;
            state.lastCurrentTime = to;
            state.lastUpdatedAt = Date.now();
          });
        });
        audio.addEventListener('loadedmetadata', () => {
          audio.__wmRecommendationListenSent = {};
          audio.__wmRecommendationListenProgress = {};
        });
      });

      return boundAny;
    }

    if (!bindAudioProgress()) {
      const timer = setInterval(() => {
        if (bindAudioProgress()) clearInterval(timer);
      }, 250);

      setTimeout(() => clearInterval(timer), 15000);
    }

    window.addEventListener('audioUnlocked', bindAudioProgress);
    window.addEventListener('wm:audio-state', bindAudioProgress);
  }

  (async function wmStartRecommendations() {
    if (window.WM_CUSTOMER_AUTH_READY && typeof window.WM_CUSTOMER_AUTH_READY.then === 'function') {
      await Promise.race([
        window.WM_CUSTOMER_AUTH_READY.catch(() => null),
        new Promise(resolve => setTimeout(resolve, 1500))
      ]);
    }

    if (!wmRecommendationsEnabled()) {
      wmBindConsentReload();
      if (WM_IS_WEEKLY_DIGS_FEED) {
        window.WM_RECOMMENDATIONS_STATUS = 'login_required';
        window.WM_CUSTOMER_LOGGED_IN = false;
        window.WM_CUSTOMER_AUTH_STATUS = { authenticated: false, source: 'weekly_digs' };
        try { sessionStorage.removeItem('wm_customer_auth_confirmed'); } catch(e) {}
        window.WM_RECOMMENDATIONS_READY = (async function () {
          wmApplyRecommendedOrder([], []);
          return [];
        })();
      } else {
        wmUseConsentFallback();
      }
      return;
    }

    if (WM_IS_PERSONALIZED_FEED) {
      window.WM_RECOMMENDATIONS_READY = (async function () {
        const source = await wmWaitForCollectionIndex();
        const cleanSource = Array.isArray(source) ? source.filter(item => wmNormalizeHandle(item)) : [];

        let ranked = [];
        try {
          ranked = await wmFetchRecommendedHandles(cleanSource);
        } catch (err) {
          if (WM_IS_WEEKLY_DIGS_FEED) {
            console.warn('[WM Recommendations] Weekly Digs unavailable.', err);
            window.WM_RECOMMENDATIONS_STATUS = 'not_ready';
            ranked = [];
          } else {
            console.warn('[WM Recommendations] Using collection-order fallback.', err);
            ranked = wmBuildFallbackRecommendations(cleanSource);
          }
        }

        wmApplyRecommendedOrder(cleanSource, ranked);
        return window.WM_ACTIVE_COLLECTION_INDEX || [];
      })();
    }

    if (FOR_YOU_GRID_VIEW) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', wmRenderForYouGrid);
      } else {
        wmRenderForYouGrid();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        wmSyncForYouGridToggle();
        wmInstallImpressionTracking();
        wmInstallInteractionTracking();
        wmInstallProductPageTracking();
        if (WM_IS_PERSONALIZED_FEED) {
          wmInstallDebugControls();
          wmApplyRecommendationDebugOverlay(document);
        }
      });
    } else {
      wmSyncForYouGridToggle();
      wmInstallImpressionTracking();
      wmInstallInteractionTracking();
      wmInstallProductPageTracking();
      if (WM_IS_PERSONALIZED_FEED) {
        wmInstallDebugControls();
        wmApplyRecommendationDebugOverlay(document);
      }
    }

    if (DEBUG_ENABLED) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node instanceof Element) wmApplyRecommendationDebugOverlay(node);
          });
        });
      });

      const startDebugObserver = () => {
        const container = document.getElementById('verticalSwipeContainer');
        if (container) observer.observe(container, { childList: true, subtree: true });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startDebugObserver);
      } else {
        startDebugObserver();
      }
    }
  })();
})();
